
























































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import { IFormItem } from '../../components/PublicQuery/PublicQuery'
import Echarts from '@/components/Echarts/Echarts.vue'
import api from '../../api'
import {
  formatDate,
  throttle,
  isEmpty,
  setDateToStart,
} from '../../utils/utils'
import { UnitControlTypeMap } from '@/model/const'
import SelectRegion from '@/components/Select/SelectRegion.vue'
import { log } from 'console'
import echarts from 'echarts'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import { start } from 'nprogress'
import { UserModule } from '@/store/modules/user'
@Component({
  components: {
    PublicQuery,
    Echarts,
    SelectRegion,
  },
})
export default class StatsUnit extends Vue {
  private noData: boolean = false
  private noData1: boolean = false
  private noData2: boolean = false
  private noData3: boolean = false
  private noData4: boolean = false
  private noData5: boolean = false
  private noData6: boolean = false
  private noData7: boolean = false
  private noData8: boolean = false
 

  private noData10: boolean = false
   private value1: boolean = true
   private valuezyl: boolean = true
   private noDatazyl: boolean = false


   private wearthModel: any = 'template'
   private wearthDev: any = []




  private queryItems: IFormItem[] = [
    {
      label: '查询日期',
      key: 'date',
      type: 'date',
      placeholder: '选择查询日期',
      // format:'yyyy-MM-dd-W',
      clearable: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
  ]
  private queryParams = {
    date: formatDate(new Date(), 'YYYY-MM-DD'),
    dateTime: formatDate(new Date(), 'YYYY-MM-DD'),
    region: [],
  }
  private xq: string = this.getweeks(new Date())
  private value: any = {}
  private val: any = {}
  private radio: any = 1
  private arrSensorDev: any = []
  private arrAirSensorDev: any = []
  private socketDev: any = []
  private arrSensorDevModel: any = 0
  private socketDevModel: any = 0
  private dimmerDev: any = []
  private dimmerDevModel: any = 0

  private arrSensorDevModel0: any = 0
  private arrAirSensorDevModel: any = 0
  private arrAirSensorDevModel2: any = 0
  private arrAirSensorDevModel3: any = 0
  private arrAirDev: any = []
  private typeName: string = '温湿度行为记录'
  private sensorType: {
    type: string
    index: number
  }[] = [
    {
      type: '温湿度行为记录',
      index: 0,
    },
    {
      type: '光照强度行为记录',
      index: 1,
    },
    {
      type: '颗粒物检测记录',
      index: 2,
    },
    {
      type: '室内空气质量记录',
      index: 3,
    },
  ]

  private arrAirDevModel: any = 0
  private arrAirDevModel1: any = 0
  private radarstate: boolean = true
  private changeSwitch() {
    console.log('i');
      const { date = '', region = [] } = this.queryParams
    if (!date) {
      this.$message.warning('请选择查询日期')
      return
    }
    if (!region || !region.length) {
      this.$message.warning('请选择查询网络')
      return
    }
    this.value.date = date
    this.value.netId = region
    var netId: any = region[3]
    
 this.getNetDevRadaData(date, region[region.length - 2],region[region.length - 1])
  }

  private option: any = {}
  private option1: any = {}
  private optionzyl: any = {}
  private option2: any = {}
  private option3: any = {}
  private option4: any = {}
  private option5: any = {}
  private option6: any = {}
  private option7: any = {}
  private option8: any = {}
  private option9: any = {}
private option10: any = {}

  private tableData: any = []
  private options: any = {}
  private netName: any = ''
  private isV3Version: any = 0

  private resdata: any = ''
  private exchange: boolean = false
  private queryChange() {
    this.getData()
  }

  private radioChange() {
    this.getData()
  }
  private radioChange1() {
    this.getData()
  }

  private radioChange11() {
    this.getData()
  }

  private radioChange2() {
    this.getData()
  }

  private radioChange3() {
    this.getData()
  }

  private radioChange4() {
    this.getData()
  }

  private socketRadioChange() {
    this.getData()
  }
    private dimmerRadioChange() {
    this.getData()
  }
  

  private typeChange() {
    this.arrSensorDevModel0 = 0
    this.exchange = true
    this.getData()
  }

  private a() {
    this.getData()
    // this.xq = this.getweeks(this.queryParams.date)
     this.upxq(this.queryParams.date)

  }

  // private bb: throttle(function(){
  //   this.b()

  // })
 private upxq(date){
  this.xq=this.getweeks(date)

 }
  private b = throttle(() => {
    var datetTime = new Date(this.queryParams.date)
    const time = datetTime.setDate(datetTime.getDate() - 1)
    this.queryParams.date = this.formatDate1(time)
    this.getData()
    let that=this
      // that.xq = that.getweeks(that.queryParams.date)

    this.$nextTick(() => {
      // that.xq = that.getweeks(that.queryParams.date)
      this.upxq(that.queryParams.date)
      console.log(that.xq);
      
    })

    // console.log(12)
  }, 1500)
  //  private bb() {
  //   let that=this
  //     throttle(
  //       that.b()
  //     , 8000)
  //   }
  private c = throttle(() => {
    var datetTime = new Date(this.queryParams.date)
    const time = datetTime.setDate(datetTime.getDate() + 1)

    if (time > Date.now()) {
      this.$message.warning('只能查询今天之前的记录')
      return
    }
    // console.log(time)
    this.queryParams.date = this.formatDate1(time)
    this.getData()
    // this.xq = this.getweeks(this.queryParams.date)
     this.upxq(this.queryParams.date)
  }, 1500)

  exportExcel() {
    /* 从表生成工作簿对象 */
    var wb = XLSX.utils.table_to_book(document.querySelector('.public-table'))
    /* 获取二进制字符串作为输出 */
    var wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'array',
    })
    try {
      FileSaver.saveAs(
        new Blob([wbout], { type: 'application/octet-stream' }),
        'sheetjs.xlsx'
      )
    } catch (e) {
      if (typeof console !== 'undefined') console.log(e, wbout)
    }
    return wbout
  }
  getSummaries(param: any) {
    const { columns, data } = param
    var switchNum: any = 0
    var autoNum: any = 0
    var openautoRate: any = 0
    var closeautoRate: any = 0

    var autoRate: any = 0
    var autoOpenCounts: any = 0
    var autoCloseCounts: any = 0
    var switchOpenCounts: any = 0
    var switchCloseCounts: any = 0

    for (let index = 0; index < data.length; index++) {
      const element = data[index]
      if (element['switchCounts'] !== '/') {
        switchNum = element['switchCounts'] + switchNum
      }
      if (element['autoCounts'] !== '/') {
        autoNum = element['autoCounts'] + autoNum
      }
      if (element['autoOpenCounts'] !== '/') {
        autoOpenCounts = element['autoOpenCounts'] + autoOpenCounts
      }
      if (element['autoCloseCounts'] !== '/') {
        autoCloseCounts = element['autoCloseCounts'] + autoCloseCounts
      }
      if (element['switchOpenCounts'] !== '/') {
        switchOpenCounts = element['switchOpenCounts'] + switchOpenCounts
      }
      if (element['switchCloseCounts'] !== '/') {
        switchCloseCounts = element['switchCloseCounts'] + switchCloseCounts
      }
    }
    autoRate = (autoNum / switchNum).toFixed(2)
    if (isNaN(autoRate)) {
      autoRate = '/'
    }
    openautoRate = (autoOpenCounts / switchOpenCounts).toFixed(2)
    if (isNaN(openautoRate)) {
      openautoRate = '/'
    }
    closeautoRate = (autoCloseCounts / switchCloseCounts).toFixed(2)
    if (isNaN(openautoRate)) {
      closeautoRate = '/'
    }

    return ['合计', '/', '/', switchNum, autoNum, switchOpenCounts, autoOpenCounts, switchCloseCounts, autoCloseCounts, autoRate, openautoRate, closeautoRate]
  }
  private getweeks(time: any) {
    let str = ''
    const t = new Date(time)
    let week = t.getDay()
    if (week == 0) {
      str = '星期日'
    } else if (week == 1) {
      str = '星期一'
    } else if (week == 2) {
      str = '星期二'
    } else if (week == 3) {
      str = '星期三'
    } else if (week == 4) {
      str = '星期四'
    } else if (week == 5) {
      str = '星期五'
    } else if (week == 6) {
      str = '星期六'
    }
    return str
  }
  private formatDate1(time: any) {
    const t = new Date(time)
    // 日期格式
    let year: any = t.getFullYear()
    // 由于 getMonth 返回值会比正常月份小 1
    let month: any = t.getMonth() + 1
    let day: any = t.getDate()
    month = month > 9 ? month : `0${month}`
    day = day > 9 ? day : `0${day}`
    return year + '-' + month + '-' + day
  }
  private getData() {
    const { date = '', region = [] } = this.queryParams
    if (!date) {
      this.$message.warning('请选择查询日期')
      return
    }
    if (!region || !region.length) {
      this.$message.warning('请选择查询网络')
      return
    }
    this.value.date = date
    this.value.netId = region
    var netId: any = region[3]
    api.getNetBleMesh(netId).then((res: any) => {
      this.netName = res.aliasName
      this.isV3Version=res.isV3Version
      this.resdata = res
    })
    if (this.exchange) {
      if (this.arrSensorDevModel === 0) {
        this.typeName = this.sensorType[this.arrSensorDevModel].type
        this.getSensorData(date, region[region.length - 2]    ,region[region.length - 1])
        // this.options = this.option2
      }
      if (this.arrSensorDevModel === 1) {
        this.typeName = this.sensorType[this.arrSensorDevModel].type
        this.getLightata(date, region[region.length - 2]    ,region[region.length - 1])
        // this.options = this.option4
      }
      if (this.arrSensorDevModel === 2) {
        this.typeName = this.sensorType[this.arrSensorDevModel].type
        this.getoPMData(date, region[region.length - 2]  ,region[region.length - 1])
        // this.options = this.option5
      }
      if (this.arrSensorDevModel === 3) {
        this.typeName = this.sensorType[this.arrSensorDevModel].type
        this.getAitQuiltyData(date, region[region.length - 2]   ,region[region.length - 1])
        // this.options = this.option6
      }
    } else {
      // this.getDevData(date, region[region.length - 1])
      // this.getNetDevRadaData(date, region[region.length - 1])
      this.getSensorData(date, region[region.length - 2]  ,region[region.length - 1])
      // this.getNetDevAirData(date, region[region.length - 1])
      // api.getDayDevCounts({ netId: region[region.length - 1], date }).then((data) => {
      // // console.log(data)
      //   this.tableData = data
      // })
    }
    this.getDevData(date, region[region.length - 2],region[region.length - 1])
    this.getNetDevRadaData(date, region[region.length - 2],region[region.length - 1])
    this.getNetDevSunshadeData(date, region[region.length - 2],region[region.length - 1])

    this.getNetDevAirData(date, region[region.length - 2]    ,region[region.length - 1])
    this.getNetDevAirData1(date, region[region.length - 2]    ,region[region.length - 1])

    this.getSocketData(date, region[region.length - 2]  ,region[region.length - 1])
    this.getDimmerData(date, region[region.length - 2]  ,region[region.length - 1])

     this.getWearthData(date)
    api
      .getDayDevCounts({ netId: region[region.length - 2], date })
      .then((data) => {
        // console.log(data)

        this.tableData = data
        let list = []
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].type === '其他') {
            
          } else {
            this.tableData[i]['closerateCounts'] = isNaN((this.tableData[i].autoCloseCounts / this.tableData[i].switchCloseCounts).toFixed(2)) ? '/' : (this.tableData[i].autoCloseCounts / this.tableData[i].switchCloseCounts).toFixed(2)
            this.tableData[i]['openrateCounts'] = isNaN((this.tableData[i].autoOpenCounts / this.tableData[i].switchOpenCounts).toFixed(2)) ? '/' : (this.tableData[i].autoOpenCounts / this.tableData[i].switchOpenCounts).toFixed(2)
            this.tableData[i]['switchCounts']=this.tableData[i]['switchOpenCounts']+this.tableData[i]['switchCloseCounts']
             this.tableData[i]['autoCounts']=this.tableData[i]['autoOpenCounts']+this.tableData[i]['autoCloseCounts']
            
            list.push(this.tableData[i])
          }
        }
        this.tableData = list
      })
  }
  private findDeviceNameByBindId(name: any, devices: any[]) {
    let results = []
    for (let i = 0; i < devices.length; i++) {
      const device = devices[i]
      if (device.useablePpe.name === name) {
        // 获取bindId
        // console.log(device.useablePpe.bindId)
        if (device.useablePpe.bindId) {
          if (device.useablePpe.bindId === '11111111111') {
            for (let j = 0; j < bindIds.length; j++) {
              const bindId = bindIds[j].trim()
              for (let k = 0; k < devices.length; k++) {
                const d = devices[k]

                // 将匹配设备的名称添加到结果列表中
                results.push(d.useablePpe.name)
              }
            }
          } else {
            const bindIds = device.useablePpe.bindId.split(',')
            for (let j = 0; j < bindIds.length; j++) {
              const bindId = bindIds[j].trim()
              for (let k = 0; k < devices.length; k++) {
                const d = devices[k]
                if (
                  d.inherentPpe.devId === bindId &&
                  !results.includes(d.useablePpe.name)
                ) {
                  // 将匹配设备的名称添加到结果列表中
                  results.push(d.useablePpe.name)
                }
              }
            }
          }
        } else {
          return results
        }
      }
    }
    // 未找到匹配设备时返回null
    return results
  }

  private changemsgz(data: any) {
    console.log(this.value1)

    if (this.value1) {

    } else {
      let result = this.findDeviceNameByBindId(data, this.resdata.dev)
      const obj = {}
      let arr1 = this.option1.legend.data
      for (let i = 0; i < arr1.length; i++) {
        const device = arr1[i]
        obj[device] = result.includes(device)
      }
      this.option1.legend.selected = obj
    }
  }
  private changemsgzx(data: any) {
    if (this.value1) {
      console.log(data);
      
      // return
    } else {
      // console.log(data)
      // console.log(this.option1)
      // console.log(this.option)

      // console.log(this.resdata)

      let result = this.option1.legend.data
      const obj = {}
      let arr1 = this.option1.legend.data
      for (let i = 0; i < arr1.length; i++) {
        const device = arr1[i]
        obj[device] = result.includes(device)
      }

      // console.log(obj)
      this.option1.legend.selected = {}
      let z = this.option1
      // this.option1 = JSON.parse(JSON.stringify(this.option1))
      this.option1 = ''
      this.option1 = z
      console.log(this.option1)
    }
  }
    private getDevAdjLogData(logs, baseVal, minTime, maxTime) {

  let logResult = logs.map((item) => [
    item.time,
    parseFloat(String(item.ope).split('=')[1] || 0) + baseVal,
    item,
  ])

  if (logs[0] && new Date(formatDate(logs[0].time, 'yyyy/MM/dd HH:mm:ss')) > minTime) {
    let open = Number(String(logs[0].ope).split('=')[1] || 0)
    logResult.unshift([minTime, open + baseVal, logs[0]])
  }
  if (
    logs[logs.length - 1] &&
    new Date(logs[logs.length - 1].time) < maxTime
  ) {
    let open = logs[logs.length - 1].ope
    /** 如果最大值大于今天的日期，只接受当前时间 */
    if (maxTime > Date.now()) {
      logResult.push([Date.now(), open + baseVal, logs[logs.length - 1]])
    } else {
      logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
    }
  }
  // // console.log(logResult);
  for (let i = 0; i < logResult.length; i++) {
    if (i == 0) {
      if (logResult[i][2].opeType == 'power' || logResult[i][2].opeType == 'gatewaymesh') {
        logResult[i][2].opeType = 'people'
        logResult[i][2].ope = 0
        if (
          logs[logs.length - 1] &&
          new Date(logs[logs.length - 1].time) < maxTime
        ) {
          let open = logs[logs.length - 1].ope
          /** 如果最大值大于今天的日期，只接受当前时间 */
          if (maxTime > Date.now()) {
            logResult.push([
              Date.now(),
              open + baseVal,
              logs[logs.length - 1],
            ])
          } else {
            logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
          }
        }

        // // console.log(logResult[i]);
      }

    }
    if (i == (logResult.length - 1)) {
      if (logResult[i][2].opeType == 'power' || logResult[i][2].opeType == 'gatewaymesh') {
        logResult[i][2].opeType = 'people'
        logResult[i][2].ope = 0
        if (
          logs[logs.length - 1] &&
          new Date(logs[logs.length - 1].time) < maxTime
        ) {
          let open = logs[logs.length - 1].ope
          /** 如果最大值大于今天的日期，只接受当前时间 */
          if (maxTime > Date.now()) {
            logResult.push([
              Date.now(),
              open + baseVal,
              logs[logs.length - 1],
            ])
          } else {
            logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
          }
        }

        // // console.log(logResult[i]);
      }

    }
    if (logResult[i][2].opeType == 'nativepeople') {
      // // console.log(logResult);
      if (i == 0) {
        logResult[i][1] = logResult[i + 1][1]
      } else {
        logResult[i][1] = logResult[i - 1][1]
      }
    }
    if (logResult[i][2].opeType == 'sensitivity') {
      // // console.log(logResult);
      logResult.splice(i, 1)
      // if (i == 0) {
      //   logResult[i][1] = logResult[i + 1][1]
      // } else {
      //   logResult[i][1] = logResult[i - 1][1]
      // }
    }
    if (logResult[i][2].opeType == 'gatewaymesh') {
      // // console.log(logResult);
      //  logResult[i][2].ope=0
      if (i == 0) {
        logResult[i][1] = logResult[i + 1][1]
      } else {
        logResult[i][1] = logResult[i - 1][1]
      }

    }

  }
  //  for(let i=0;i<logResult.length;i++){
  //   if(logResult[i][2].opeType=='power'){
  //     logResult.splice(i--,1)
  //     // // console.log(logResult[i]);

  //   }
  //  }

  // // console.log(logResult);
  let x = logResult.length
  while (x--) {
    if (logResult[x][2].opeType == 'power' || logResult[x][2].opeType == 'sensitivity') {
      logResult.splice(x, 1)
    }
  }



  return logResult
}
  // 获取设备行为记录数据
  private getDevData(date: any, netId: any,groupId:any) {
    let that=this
    api.getNetDevBehavior({ date, netId: netId,groupId }).then((data) => {
      const { people = [], devs = [],adjustSwitches=[] }: { people: any[]; devs: any[];adjustSwitches:any[] } =
        data || {}
      this.noData = !people.length && !devs.length
      // console.log('单元' + JSON.stringify(devs))
      if (this.noData) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      // console.log(maxTime);
  let idx = devs.length
      for (let index = 0; index < devs.length; index++) {
        const element = devs[index]
      }

        let list = devs.concat(adjustSwitches)
  // list = pxsortsz(list)
      // for(let i=0;i<devs.length;i++){
      //   devs[i]['name']=devs[i].devName
      // }
      // console.log(devs)
      this.option = {
        title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + this.netName + '设备行为记录曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any[]) {
            let result = ''
            result += params.reduceRight((prev, curr, index) => {
              if (index === params.length - 1) {
                prev += `${formatDate(curr.axisValue)}<br>`
              }
              let ppe=curr.value[1] % 2 ? '开启' : '关闭'
              if(curr.value[2].adjustOpe){
                let x=''
                if(curr.value[2].adjustOpe=='noack'){
                  x='-控制失败-无响应'
                   ppe=x
                }
               else if(curr.value[2].adjustOpe=='lost')
               {
                x='-控制失败-设备掉线'
                 ppe=x
               }
               else{
                 ppe='-'+ppe
                if(curr.value[2].adjustOpe.split('=').length==2){
                   ppe='-'+ppe+'-'+curr.value[2].adjustOpe

                }
                
               }
               
              }
              let r=null
             
             
              if(that.isV3Version){
                   r = (prev += `${curr.marker}${curr.seriesName} ${
             curr.value[2].devActExplain|| ''
              }${ppe}<br>`)
              }else{
  r = (prev += `${curr.marker}${curr.seriesName} ${
                UnitControlTypeMap.get(curr.value[2].opeType) || ''
              }${ppe}<br>`)
              }
              
            //   const r = (prev += `${curr.marker}${curr.seriesName} ${
            //  curr.value[2].devActExplain|| ''
            //   }${ppe}<br>`)
              return r
            }, result)
            return result
          },
        },

        legend: {
          // data: devs.map((item) => item.devName).reverse(),
      data: list.map((item) => item.devName).reverse(),

          // data:devs,
          itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          textStyle: {
            fontSize: 14,
          },
          width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
        //  selectorPosition:'end'

        },
        grid: {
          left: '5%',
          right: '5%',
          bottom: '10%',
          containLabel: true,
        },
        toolbox: {
          
          feature: {
          
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {
              name: '单元分析',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
        xAxis: {
          type: 'time',
          splitNumber: 24,
          boundaryGap: true,
          min: minTime,
          max: maxTime,
          splitLine: {
            // 网格线
            show: false,
          },
          axisLabel: {
            formatter: function(value: any, index: number) {
              // 格式化成月/日，只在第一个刻度显示年份
              if (value % 3600000) {
                return formatDate(value, 'HH:mm:ss')
              } else {
                return formatDate(value, 'HH:mm')
              }
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            // y轴
            show: false,
          },
          axisTick: {
            // y轴刻度线
            show: false,
          },
          axisLabel: {
            show: false,
          },
           max: (devs.length + adjustSwitches.length) > 0 ? ((devs.length + adjustSwitches.length) * 2) + 2 : 3,
          // "splitLine": {     //网格线
          //   "show": false
          // }
        },
        series: [
             ...adjustSwitches.map((devItem, index) => {
        // // // console.log(devItem,index);
        const {
          devName = '', logs = []
        } = devItem || {}
        // // console.log(getDevAdjLogData(logs, ((index+idx) * 2)  +2, minTime, maxTime)); 
        return {
          name: devItem.devName || '',
          type: 'line',
          step: 'end',
          // smooth: true,
          showSymbol: false,
          lineStyle: {
            width: 3,
          },
          data: this.getDevAdjLogData(logs, ((index + idx) * 2) + 2, minTime, maxTime),
       

        }
      }),
          ...devs.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
            }: { devName: string; logs: any[] } = devItem || {}
            const logData = this.getDevLogData(logs, index * 2 + 2, minTime, maxTime)
            return {
              name: devItem.devName || '',
              type: 'line',
              step: 'end',
              showSymbol: false,
              lineStyle: {
                width: 3,
              },
              markPoint: {
                data: [
                  ...this.getDevbjData(logData),
                  ...this.getRebootMarkPoints(logData)
                ],
              },
              data: logData,
            }
          }),
          {
            name: '雷达',
            type: 'line',
            step: 'end',
            color: '#57E099',
            symbol: 'none',
            showSymbol: false,
            data: this.getPeopleData(people),
            tooltip: {
              show: false,
            },
            areaStyle: {
              color: '#57E099',
              // normal: {},
              // shadowColor: 'rgba(0, 0, 0, 0.5)',
              // shadowOffsetY: -5,
            },
            lineStyle: {
              color: 'transparent',
            },
          },
        ],
      }
    })
  }


  // 获取雷达行为记录数据
  private getNetDevRadaData(date: any, netId: any,groupId:any) {
    api.getNetDevRadarBehavior({ date, netId: netId,groupId ,filter:this.radarstate}).then((data) => {
      const { people = [], devs = [] }: { people: any[]; devs: any[] } =
        data || {}
      this.noData1 = !people.length && !devs.length
      // console.log('devs' + JSON.stringify(devs))
      if (this.noData1) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      for (let index = 0; index < devs.length; index++) {
        const element = devs[index]
      }
      this.option1 = {
        title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + this.netName + '雷达行为记录曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any[]) {
            let result = ''
            result += params.reduceRight((prev, curr, index) => {
              if (index === params.length - 1) {
                prev += `${formatDate(curr.axisValue)}<br>`
              }
              console.log(curr.value[2].opeType);
              
              const r = (prev += `${curr.marker}${curr.seriesName} ${
                UnitControlTypeMap.get(curr.value[2].opeType) || ''
              }${curr.value[1] % 2 ? '开启' : '关闭'}<br>`)
              return r
            }, result)
            return result
          },
        },
        legend: {
          data: devs.map((item) => item.devName).reverse(),
          itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          selected: {},
          textStyle: {
            fontSize: 14,
          },
            width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {
              name: '单元分析',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
        xAxis: {
          type: 'time',
          splitNumber: 24,
          boundaryGap: true,
          min: minTime,
          max: maxTime,
          splitLine: {
            // 网格线
            show: false,
          },
          axisLabel: {
            formatter: function(value: any, index: number) {
              // 格式化成月/日，只在第一个刻度显示年份
              if (value % 3600000) {
                return formatDate(value, 'HH:mm:ss')
              } else {
                return formatDate(value, 'HH:mm')
              }
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            // y轴
            show: false,
          },
          axisTick: {
            // y轴刻度线
            show: false,
          },
          axisLabel: {
            show: false,
          },
          max: devs.length > 0 ? devs.length * 2 + 2 : 3,
          // "splitLine": {     //网格线
          //   "show": false
          // }
        },
        series: [
          ...devs.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
            }: { devName: string; logs: any[] } = devItem || {}
            // console.log('单元分析' + JSON.stringify(this.getDevLogData(logs, (index * 2) + 2, minTime, maxTime)))
            return {
              name: devItem.devName || '',
              type: 'line',
              step: 'end',
              showSymbol: false,
              lineStyle: {
                width: 3,
              },
              markPoint: {
                data: [
                  ...this.getDevbjData(
                    this.getDevLogData(logs, index * 2 + 2, minTime, maxTime)
                  ),
                  ...this.getRebootMarkPoints(
                    this.getDevLogData(logs, index * 2 + 2, minTime, maxTime)
                  )
                ],
              },

              data: this.getDevLogData(logs, index * 2 + 2, minTime, maxTime),
            }
          }),
          {
            name: '雷达',
            type: 'line',
            step: 'end',
            color: '#57E099',
            symbol: 'none',
            showSymbol: false,
            data: this.getPeopleData(people),

            tooltip: {
              show: false,
            },
            areaStyle: {
              color: '#57E099',
              // normal: {},
              // shadowColor: 'rgba(0, 0, 0, 0.5)',
              // shadowOffsetY: -5,
            },
            lineStyle: {
              color: 'transparent',
            },
          },

          ...devs.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
            }: { devName: string; logs: any[] } = devItem || {}
            // console.log('单元分析' + JSON.stringify(this.getDevLogData(logs, (index * 2) + 2, minTime, maxTime)))
            return {
              name: devItem.devName || '',
              type: 'line',
              step: 'end',
              showSymbol: false,
              lineStyle: {
                width: 3,
              },
              markPoint: {
                symbol: '',
                symbolSize: 5,
                data: this.getDevbjDatanoman(
                  this.getDevLogData(logs, index * 2 + 2, minTime, maxTime)
                ),
              },

              data: this.getDevLogData(logs, index * 2 + 2, minTime, maxTime),
            }
          }),
          {
            name: '雷达',
            type: 'line',
            step: 'end',
            color: '#57E099',
            symbol: 'none',
            showSymbol: false,
            data: this.getPeopleData(people),

            tooltip: {
              show: false,
            },
            areaStyle: {
              color: '#57E099',
              // normal: {},
              // shadowColor: 'rgba(0, 0, 0, 0.5)',
              // shadowOffsetY: -5,
            },
            lineStyle: {
              color: 'transparent',
            },
          },
        ],
      }
    })
  }

    // 获取遮阳帘行为记录数据
  private getNetDevSunshadeData(date: any, netId: any,groupId:any) {
    // let isV3Version=this.isV3Version
    let that=this
    api.getNetSmartCurtainBehaviorV3({ date, netId: netId,groupId }).then((data) => {
      const { people = [], devs = [] }: { people: any[]; devs: any[] } =
        data || {}
      this.noDatazyl = !people.length && !devs.length
      // console.log('devs' + JSON.stringify(devs))
      if (this.noDatazyl ) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      for (let index = 0; index < devs.length; index++) {
        const element = devs[index]
      }
      this.optionzyl = {
        title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + this.netName + '雷达行为记录曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any[]) {
         let result = ''
        result += params.reduceRight((prev, curr, index) => {
          if (index === params.length - 1) {
            prev += `${formatDate(curr.axisValue)}<br>`
          }
          console.log( 'isv3',that.isV3Version);
          let x = String(curr.value[2].ope)
          //  let r=''
          if (x.indexOf('=') != -1) {
            let r = prev += `${curr.marker}${curr.seriesName} ${that.isV3Version?curr.value[2].devActExplain:(UnitControlTypeMap.get(curr.value[2].opeType) || '')}${'<br>'+x.split('=')[1]*100+'%亮度' }<br>`
            return r
          } else {
            let r = prev += `${curr.marker}${curr.seriesName} ${that.isV3Version?curr.value[2].devActExplain:(UnitControlTypeMap.get(curr.value[2].opeType) || '')}${curr.value[1] % 2 ? '开启' : '关闭'}<br>`
            return r
          }

        }, result)
        return result
      },
        },
        legend: {
          data: devs.map((item) => item.devName).reverse(),
          itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          selected: {},
          textStyle: {
            fontSize: 14,
          },
            width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {
              name: '单元分析',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
        xAxis: {
          type: 'time',
          splitNumber: 24,
          boundaryGap: true,
          min: minTime,
          max: maxTime,
          splitLine: {
            // 网格线
            show: false,
          },
          axisLabel: {
            formatter: function(value: any, index: number) {
              // 格式化成月/日，只在第一个刻度显示年份
              if (value % 3600000) {
                return formatDate(value, 'HH:mm:ss')
              } else {
                return formatDate(value, 'HH:mm')
              }
            },
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            // y轴
            show: false,
          },
          axisTick: {
            // y轴刻度线
            show: false,
          },
          axisLabel: {
            show: false,
          },
          max: devs.length > 0 ? devs.length * 2 + 2 : 3,
          // "splitLine": {     //网格线
          //   "show": false
          // }
        },
        series: [
              {
            name: '雷达',
            type: 'line',
            step: 'end',
            color: '#57E099',
            symbol: 'none',
            showSymbol: false,
            data: this.getPeopleData(people),

            tooltip: {
              show: false,
            },
            areaStyle: {
              color: '#57E099',
              // normal: {},
              // shadowColor: 'rgba(0, 0, 0, 0.5)',
              // shadowOffsetY: -5,
            },
            lineStyle: {
              color: 'transparent',
            },
          },

          ...devs.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
            }: { devName: string; logs: any[] } = devItem || {}
            // console.log('单元分析' + JSON.stringify(this.getDevLogData(logs, (index * 2) + 2, minTime, maxTime)))
            return {
              name: devItem.devName || '',
              type: 'line',
              step: 'end',
              showSymbol: false,
              lineStyle: {
                width: 3,
              },
              // markPoint: {
              //   symbol: '',
              //   symbolSize: 5,
              //   data: this.getDevbjDatanoman(
              //     this.getDevsunshadeLogData(logs, index * 2 + 2, minTime, maxTime)
              //   ),
              // },

              data: this.getDevsunshadeLogData(logs, index * 2 + 2, minTime, maxTime),
            }
          }),
          {
            name: '雷达',
            type: 'line',
            step: 'end',
            color: '#57E099',
            symbol: 'none',
            showSymbol: false,
            data: this.getPeopleData(people),

            tooltip: {
              show: false,
            },
            areaStyle: {
              color: '#57E099',
              // normal: {},
              // shadowColor: 'rgba(0, 0, 0, 0.5)',
              // shadowOffsetY: -5,
            },
            lineStyle: {
              color: 'transparent',
            },
          },
        ],
      }
    })
  }
  // 获取空调温度记录数据
  private getNetDevAirData(date: any, netId: any,groupId:any) {
    api.getNetDevAirBehavior({ date, netId: netId,groupId }).then((data) => {
      const {
        defaultSet = '',
        devs = [],
      }: { defaultSet: string; devs: any[] } = data || {}
      this.noData3 = !devs.length
 

      let defaultWendu: Number
      if (devs.length === 0) {
        this.noData3 = true
   

      } else {
        this.noData3 = false
     
      }
      if (defaultSet !== null) {
        // console.log('111'+defaultSet);

        defaultWendu = Number(defaultSet.split('=')[1])
        // if((defaultSet.split('=')[0])=='close'){
        //    defaultWendu = 0

        // }
      } else {
        defaultWendu = 0
      }
      if (this.noData3) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      const arr = []
      const devss = []
      let index1: any = this.arrAirDevModel
      devss.push(devs[index1])
      if (devs[index1] !== undefined) {
        for (let index: any = 0; index < devs.length; index++) {
          const obj = { index: Number, devName: String }
          obj['index'] = index
          obj['devName'] = devs[index]['devName']
          arr.push(obj)
        }
        this.arrAirDev = arr
        this.option3 = {
          title: {
            textStyle: {
              color: '#333',
              fontStyle: 'normal',
              fontWeight: '200',
              fontFamily: 'sans-serif',
              fontSize: 15,
            },
            text: date + '日' + this.netName + '空调温度记录曲线图',
            x: 'center',
            y: 'bottom',
            padding: [100, 0, 0, 0],
          },
          tooltip: {
            trigger: 'axis',
            formatter: function(params: any[]) {
              let result = ''
              result += params.reduceRight((prev, curr, index) => {
                if (index === params.length - 1) {
                  prev += `${formatDate(curr.axisValue)}<br>`
                }
                let sz = curr.value[2].mode
                // console.log(sz);

                if (sz == 'auto') {
                  sz = 'autosz'
                }
                let speed=curr.value[2].speed

                const r = (prev += `${curr.marker}${curr.seriesName} ${
                  UnitControlTypeMap.get(curr.value[2].opeType) || ''
                }${UnitControlTypeMap.get(sz) || ''}${UnitControlTypeMap.get(speed) || ''}${
                  curr.value[1] || '关'
                }<br>`)
                return r
              }, result)
              return result
            },
          },
          legend: {
            data: devss.map((item) => item.devName).reverse(),
            itemHeight: 10, // 改变圆圈大小
            icon: 'circle',
            textStyle: {
              fontSize: 14,
            },
              width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true,
          },
          toolbox: {
            feature: {
              dataZoom: {
                yAxisIndex: 'none',
              },
              restore: {},
              saveAsImage: {
                name: '单元分析',
              },
            },
          },
          dataZoom: [
            {
              type: 'inside',
              filterMode: 'none',
              throttle: 50,
            },
          ],
          xAxis: {
            type: 'time',
            splitNumber: 24,
            boundaryGap: true,
            min: minTime,
            max: maxTime,
            splitLine: {
              // 网格线
              show: false,
            },
            axisLabel: {
              formatter: function(value: any, index: number) {
                // 格式化成月/日，只在第一个刻度显示年份
                if (value % 3600000) {
                  return formatDate(value, 'HH:mm:ss')
                } else {
                  return formatDate(value, 'HH:mm')
                }
              },
            },
          },
          yAxis: [
            {
              type: 'value',
              name: '温度',
              min: 15,
              max: 30,
              axisLabel: {
                formatter: '{value}℃',
                // color: '#27719F',
              },
            },
          ],
          series: [
            ...devss.map((devItem: any, index) => {
              const {
                devName = '',
                logs = [],
                defaultSet = '',
              }: {
                devName: string
                logs: any[]
                defaultSet: string
              } = devItem || {}
              // console.log('====' + JSON.stringify(this.getAirLogData(logs, 0, minTime, maxTime)))
              return {
                name: devItem.devName || '',
                type: 'line',
                step: 'end',
                showSymbol: false,
                connectNulls: false,
                markLine: {
                  symbol: 'none',
                  data: [
                    {
                      silent: false,
                      lineStyle: {
                        color: '#3398DB',
                      },
                      label: {
                        position: 'end',
                        formatter: '默认温度',
                      },
                      yAxis: defaultWendu,
                    },
                  ],
                },
                lineStyle: {
                  width: 3,
                },
                data: this.getAirLogData(logs, 0, minTime, maxTime),
              }
            }),
          ],
        }
       
      }
    })
  }


 // 获取空调温度记录数据
 private getNetDevAirData1(date: any, netId: any,groupId:any) {
    api.getNetDevAirBehavior({ date, netId: netId,groupId }).then((data) => {
      const {
        defaultSet = '',
        devs = [],
      }: { defaultSet: string; devs: any[] } = data || {}
  const people = []
      this.noData10 = !devs.length

      let defaultWendu: Number
      if (devs.length === 0) {
   
        this.noData10 = true

      } else {
       
        this.noData10 = false
      }
      if (defaultSet !== null) {
        // console.log('111'+defaultSet);

        defaultWendu = Number(defaultSet.split('=')[1])
        // if((defaultSet.split('=')[0])=='close'){
        //    defaultWendu = 0

        // }
      } else {
        defaultWendu = 0
      }
      if (this.noData10) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      const arr = []
      const devss = []
      let index1: any = this.arrAirDevModel1
      devss.push(devs[index1])
      if (devs[index1] !== undefined) {
        for (let index: any = 0; index < devs.length; index++) {
          const obj = { index: Number, devName: String }
          obj['index'] = index
          obj['devName'] = devs[index]['devName']
          arr.push(obj)
        }
        this.arrAirDev = arr

//         this.option10 = {
//         title: {
//           textStyle: {
//             color: '#333',
//             fontStyle: 'normal',
//             fontWeight: '200',
//             fontFamily: 'sans-serif',
//             fontSize: 15,
//           },
//           text: date + '日' + this.netName + '雷达行为记录曲线图',
//           x: 'center',
//           y: 'bottom',
//           padding: [100, 0, 0, 0],
//         },
//         tooltip: {
//           trigger: 'axis',
//           formatter: function(params: any[]) {
//             let result = ''
//             result += params.reduceRight((prev, curr, index) => {
//               if (index === params.length - 1) {
//                 prev += `${formatDate(curr.axisValue)}<br>`
//               }
//               const r = (prev += `${curr.marker}${curr.seriesName} ${
//                 UnitControlTypeMap.get(curr.value[2].opeType) || ''
//               }${curr.value[1] % 2 ? '开启' : '关闭'}<br>`)
//               return r
//             }, result)
//             return result
//           },
//         },
//         legend: {
//           data: ['空调开关', '水阀', '风机'],
//           itemHeight: 10, // 改变圆圈大小
//           icon: 'circle',
//           selected: {},
//           textStyle: {
//             fontSize: 14,
//           },
//             width:"80%",
          
       
//         },
//         grid: {
//           left: '3%',
//           right: '4%',
//           bottom: '10%',
//           containLabel: true,
//         },
//         toolbox: {
//           feature: {
//             dataZoom: {
//               yAxisIndex: 'none',
//             },
//             restore: {},
//             saveAsImage: {
//               name: '单元分析',
//             },
//           },
//         },
//         dataZoom: [
//           {
//             type: 'inside',
//             filterMode: 'none',
//             throttle: 50,
//           },
//         ],
//         xAxis: {
//           type: 'time',
//           splitNumber: 24,
//           boundaryGap: true,
//           min: minTime,
//           max: maxTime,
//           splitLine: {
//             // 网格线
//             show: false,
//           },
//           axisLabel: {
//             formatter: function(value: any, index: number) {
//               // 格式化成月/日，只在第一个刻度显示年份
//               if (value % 3600000) {
//                 return formatDate(value, 'HH:mm:ss')
//               } else {
//                 return formatDate(value, 'HH:mm')
//               }
//             },
//           },
//         },
//         yAxis: {
//           type: 'value',
//           // type: 'category',
          
//           axisLine: {
//             // y轴
//             show: false,
//           },
//           axisTick: {
//             // y轴刻度线
//             show: false,
//           },
//           axisLabel: {
//             show: false,
//           },
//           max: devs.length > 0 ? devs.length * 2 + 2 : 3,
//           splitLine: {     //网格线
//             show: true
//           }
//         },
//         series: [
       

//           {
//             name: '空调开关',
//             type: 'line',
//               step: 'end',
//               showSymbol: false,
//               lineStyle: {
//                 width: 3,
//               },
           
//             data: this.getAirLogData1(devss[0].logs,8, minTime, maxTime),

          
//           },

//           {
//             name: '水阀',
//             type: 'line',
//               step: 'end',
//               showSymbol: false,
//               lineStyle: {
//                 width: 3,
//               },
//             data: this.getAirLogData2(devss[0].logs,4, minTime, maxTime),

          
//           },

//           {
//             name: '风机',
//             type: 'bar',
//             stack: 'duration',
//       label: {
//         show: false
//       },
//       emphasis: {
//         focus: 'series'
//       },
//       itemStyle: {
//       color: '#57E099', // 绿色
//     },
//     barWidth: '50',
  
//       data:  this.getAirLogData3(devss[0].logs,0, minTime, maxTime),
//           },
// //     {
// //     name: '风机',
// //     type: 'custom',
// //     renderItem: function (params, api) {
// //         const categoryIndex = api.value(0);
// //         const start = api.coord([api.value(1), categoryIndex]);
// //         const end = api.coord([api.value(2), categoryIndex]);
// //         const height = api.size([0, 1])[1] * 0.5; // 调整高度以适应阶梯状效果

// //         const rectShape = echarts.graphic.clipRectByRect(
// //             {
// //                 x: start[0],
// //                 y: start[1] - height / 2,
// //                 width: end[0] - start[0],
// //                 height: height,
// //             },
// //             {
// //                 x: params.coordSys.x,
// //                 y: params.coordSys.y,
// //                 width: params.coordSys.width,
// //                 height: params.coordSys.height,
// //             }
// //         );

// //         // 针对缺失的矩形形状处理
// //         return rectShape && {
// //             type: 'rect',
// //             shape: rectShape,
// //             style: api.style(),
// //         };
// //     },
// //     encode: {
// //         // 将数据的维度映射到X轴和Y轴
// //         x: [1, 2], // X轴的起始和结束位置
// //         y: 0, // Y轴的位置
// //     },
// //     dimensions: [null, null, '开始时间', '结束时间'],
// //     data: [
// //         // 填写数据格式，确保包含起始时间和结束时间
// //         [0, 1, 4], // 第1个数据条
// //         [1, 2, 5], // 第2个数据条
// //         [2, 3, 6], // 第3个数据条...
// //     ],
// // }
         

         
//         ],
//       }



this.option10 ={
          title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + this.netName + '空调行为记录曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any[]) {
            let result = ''
            result += params.reduceRight((prev, curr, index) => {
              // console.log(curr);
              
              if (index === params.length - 1) {
                prev += `${formatDate(curr.axisValue)}<br>`
              }
              let r=''
              if(curr.seriesName!='风机'){
             r = (prev += `${curr.marker}${curr.seriesName} ${
                UnitControlTypeMap.get(curr.value[2].opeType) || ''
              }${curr.value[1] % 2 ? '开启' : '关闭'}<br>`)}
              if(curr.value[4]){
                r = (prev += `${curr.marker}${curr.seriesName} ${
                UnitControlTypeMap.get(curr.value[2].opeType) || ''
              }${curr.value[4]=='1'?'低风':curr.value[4]=='2'?'中风':'高风'}<br>`)
              }




              return r
            }, result)
            return result
          },
        },
            dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
    legend: {
        data: ['空调开关', '水阀', '高风','中风','低风'],
        textStyle: { fontSize: 14 },
        left: 'center'
    },
    grid: {
        left: '3%',
        right: '4%',
        bottom: '10%',
        containLabel: true,
    },
        xAxis: {
          type: 'time',
          splitNumber: 24,
          boundaryGap: true,
          min: minTime,
          max: maxTime,
          splitLine: {
            // 网格线
            show: false,
          },
          axisLabel: {
            formatter: function(value: any, index: number) {
              // 格式化成月/日，只在第一个刻度显示年份
              if (value % 3600000) {
                return formatDate(value, 'HH:mm:ss')
              } else {
                return formatDate(value, 'HH:mm')
              }
            },
          },
    },
    yAxis: {
        type: 'value',
        name: '状态',
        min: 0,
        max: devs.length > 0 ? 10 : 3,
        interval: 1,
        axisLabel: {
            formatter: function (value) {
                // 根据状态值返回不同的标签
                switch (value) {
                    // case 0: return '关闭';
                    case 1: return '风机';
                    case 4: return '水阀';
                    case 8: return '空调开关';
                    default: return '';
                }
            }
        },
        splitLine: { show: true },
    },
    series: [
        {
            name: '空调开关',
            type: 'line',
            step: 'end',
            showSymbol: false,
            lineStyle: {
                color: '#FF0000', //红色
                width: 2,
            },
            data: this.getAirLogData1(devss[0].logs,8, minTime, maxTime),

            // data: [
            //     // 这里填写空调开关的时间和状态数据
            //     ['2023-10-31 05:00:00', 1],
            //     ['2023-10-31 06:00:00', 1],
            //     ['2023-10-31 07:00:00', 0],
            //     // 继续添加更多数据...
            // ],
        },
        {
            name: '水阀',
            type: 'line',
            step: 'end',
            showSymbol: false,
            lineStyle: {
                color: '#00BFFF', //蓝色
                width: 2,
            },
                    data: this.getAirLogData2(devss[0].logs,4, minTime, maxTime),

        },
        {
            name: '风机',
            type: 'custom',
            renderItem: function (params, api) {
                const categoryIndex = api.value(0); // Y轴的状态
                const start = api.coord([api.value(1), categoryIndex]); // 起始时间坐标
                const end = api.coord([api.value(2), categoryIndex]); // 结束时间坐标
                const height = api.size([0, 1])[1] ;

                const rectShape = echarts.graphic.clipRectByRect(
                    {
                        x: start[0],
                        y: start[1] - height / 2,
                        width: end[0] - start[0],
                        height: height,
                    },
                    {
                        x: params.coordSys.x,
                        y: params.coordSys.y,
                        width: params.coordSys.width,
                        height: params.coordSys.height,
                    }
                );

                return rectShape && {
                    type: 'rect',
                    shape: rectShape,
                    // style: api.style(),
                    style: {
                        fill: api.value(3), // 使用数据中的第三个元素作为颜色
                    },
                };
            },
            encode: {
                x: [1, 2], // 用数据中的哪些维度做X轴
                y: 0,
            },
            dimensions: [null, null, '开始时间', '结束时间','颜色','状态'],

            data: this.getAirLogData3(devss[0].logs,4, minTime, maxTime),
            
            // data: [
            //     // 这里填写风机的开始和结束时间数据
            //     [1, '2024-12-12T09:15:10.000+0800', '2024-12-12T09:50:10.000+0800','#57E099'], //开始时间和结束时间
            //     [1, '2024-12-12T10:15:10.000+0800', '2024-12-12T15:15:10.000+0800', '#FFA500'],
            //     [1, '2024-12-12T16:15:10.000+0800', '2024-12-12T16:50:10.000+0800', '#FF6347'],
            //     // 继续添加更多数据...
            // ],
        },
        {
            name: '高风',
            type: 'custom',
          color: '#3b7c47',
     
          },
            {
            name: '中风',
            type: 'custom',
            color: '#58d466',
          
          },
            {
            name: '低风',
            type: 'custom',
            color: '#b7dfbf',
          
          }
      
    ],
};
       
       
      }
    })
  }

  // 获取传感器记录数据
  private getSensorData(date: any, netId: any,groupId:any) {
    api.getNetDevSensorBehavior({ date, netId: netId, groupId: groupId }).then((data) => {
      const { people = [], devs = [] }: { people: any[]; devs: any[] } =
        data || {}
      this.noData2 = !people.length && !devs.length
      // console.log('dev' + JSON.stringify(devs))
      if (this.noData2) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      let datas: any = []
      let arrTime: any = []
      let arrWendu: any = []
      let arrShidu: any = []
      let arrGzqd: any = []
      this.arrSensorDev = []
      for (let index: any = 0; index < devs.length; index++) {
        let sensorDev = {
          index: Number,
          value: String,
        }
        sensorDev.index = index
        sensorDev.value = devs[index].devName
        this.arrSensorDev.push(sensorDev)
        if (index === this.arrSensorDevModel0) {
          const element = devs[index].logs
          this.option2 = {
            title: {
              textStyle: {
                color: '#333',
                fontStyle: 'normal',
                fontWeight: '200',
                fontFamily: 'sans-serif',
                fontSize: 15,
              },
              text: date + '日' + this.netName + '传感器记录曲线图',
              x: 'center',
              y: 'bottom',
              padding: [100, 0, 0, 0],
            },
            color: ['#1890ff', '#1f9'],
            grid: {
              left: '3%',
              right: '4%',
              bottom: '10%',
              containLabel: true,
            },
            legend: {
              data: ['温度', '湿度'],
              selected: {},
              itemGap: 20,
              right: '10%',
                width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
            },
            tooltip: {
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
              },
            },
            dataZoom: [
              {
                type: 'inside',
                filterMode: 'none',
                throttle: 50,
              },
            ],
            toolbox: {
              feature: {
                dataZoom: {
                  yAxisIndex: 'none',
                },
                restore: {},
                saveAsImage: {
                  name: '传感器分析',
                },
              },
            },
            xAxis: [
              {
                type: 'time',
                splitNumber: 24,
                boundaryGap: true,
                min: minTime,
                max: maxTime,
                splitLine: {
                  // 网格线
                  show: false,
                },
                axisLabel: {
                  formatter: function(value: any, index: number) {
                    // 格式化成月/日，只在第一个刻度显示年份
                    if (value % 3600000) {
                      return formatDate(value, 'HH:mm:ss')
                    } else {
                      return formatDate(value, 'HH:mm')
                    }
                  },
                },
              },
            ],
            yAxis: [
              {
                type: 'value',
                name: '湿度',
                position: 'right',
                min: 0,
                axisLabel: {
                  formatter: '{value}%',
                  // color: '#27719F',
                },
                axisPointer: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    // color: '#27719F',
                  },
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    // color: '#144463',
                  },
                },
              },
              {
                type: 'value',
                name: '温度',
                position: 'left',
                axisLabel: {
                  formatter: '{value} ℃',
                  // color: '#27719F',
                },
                max: 40,
                splitLine: {
                  show: false,
                },
                axisPointer: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    // color: '#27719F',
                  },
                },
              },
            ],
            series: [
              {
                type: 'line',
                name: '湿度',
                symbolSize: 3,
                symbol: 'circle',
                barWidth: '12%',
                data: this.getDevSensorShiduLogData(
                  devs[index].logs,
                  0,
                  minTime,
                  maxTime
                ),
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                markLine: {
                  data: [{ type: 'average', name: '平均值' }],
                },
                itemStyle: {
                  normal: {
                    barBorderRadius: [10, 10, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                      {
                        offset: 0,
                        color: '#42B7FD',
                      },
                      {
                        offset: 1,
                        color: '#42B7FD',
                      },
                    ]),
                  },
                },
              },
              {
                type: 'line',
                name: '温度',
                yAxisIndex: 1,
                itemStyle: {
                  color: '#C44D4E',
                },
                symbolSize: 3,
                symbol: 'circle',
                data: this.getDevSensorWenduLogData(
                  devs[index].logs,
                  0,
                  minTime,
                  maxTime
                ),
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                markLine: {
                  data: [{ type: 'average', name: '平均值' },

                
                  ],
                },
              },
            ],
          }
          this.options = this.option2
        }
      }
    })
  }
  // 获取空气传感器数据
  private getLightata(date: any, netId: any,  groupId:any) {
    api.getNetDevAirSensorBehavior({ date, netId: netId, groupId: groupId }).then((data) => {
      const { people = [], devs = [] }: { people: any[]; devs: any[] } =
        data || {}
      this.noData4 = !people.length && !devs.length
      // console.log('dev' + JSON.stringify(devs))
      if (this.noData4) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      let datas: any = []
      let arrTime: any = []
      let arrGzqd: any = []
      let arrCO2: any = []
      let arrVOC: any = []
      this.arrSensorDev = []
      const devss = []
      let index1: any = this.arrSensorDevModel0
      devss.push(devs[index1])
      // console.log('devss' + JSON.stringify(devss))
      for (let index: any = 0; index < devs.length; index++) {
        let sensorDev = {
          index: Number,
          value: String,
        }
        sensorDev.index = index
        sensorDev.value = devs[index].devName
        this.arrSensorDev.push(sensorDev)
        if (index === this.arrSensorDevModel0) {
          const element = devs[index].logs
          arrGzqd = this.getDevSensorGzqdLogData(
            devs[index1].logs,
            0,
            minTime,
            maxTime
          )
          arrCO2 = this.getDevSensorCO2LogData(
            devs[index1].logs,
            0,
            minTime,
            maxTime
          )
          arrVOC = this.getDevSensorVOCLogData(
            devs[index1].logs,
            0,
            minTime,
            maxTime
          )
        }
      }
      this.option4 = {
        title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + this.netName + '光照强度记录曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any[]) {
            let result = ''
            result += params.reduceRight((prev, curr, index) => {
              if (index === params.length - 1) {
                prev += `${formatDate(curr.axisValue)}<br>`
              }
              const r = (prev += `${curr.marker}${curr.seriesName} ${
                UnitControlTypeMap.get(curr.value[2].opeType) || ''
              }${curr.value[1] || '关'}<br>`)
              return r
            }, result)
            return result
          },
        },
        legend: {
          data: devss.map((item) => item.devName).reverse(),
          itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          textStyle: {
            fontSize: 14,
          },
            width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {
              name: '单元分析',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
        xAxis: {
          type: 'time',
          splitNumber: 24,
          boundaryGap: true,
          min: minTime,
          max: maxTime,
          splitLine: {
            // 网格线
            show: false,
          },
          axisLabel: {
            formatter: function(value: any, index: number) {
              // 格式化成月/日，只在第一个刻度显示年份
              if (value % 3600000) {
                return formatDate(value, 'HH:mm:ss')
              } else {
                return formatDate(value, 'HH:mm')
              }
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '光照强度',
            axisLabel: {
              formatter: '{value} Lx',
              // color: '#27719F',
            },
          },
        ],
        series: [
          ...devss.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
              defaultSet = '',
            }: { devName: string; logs: any[]; defaultSet: string } = devItem ||
            {}
            return {
              name: devItem.devName || '',
              type: 'line',
              step: 'end',
              showSymbol: false,
              connectNulls: false,
              lineStyle: {
                width: 3,
              },
              data: this.getDevSensorGzqdLogData(logs, 0, minTime, maxTime),
            }
          }),
        ],
      }
      this.options = this.option4
    })
  }
  private getoPMData(date: any, netId: any,groupId:any) {
    api.getNetDevAirSensorBehavior({ date, netId: netId , groupId: groupId }).then((data) => {
      const { people = [], devs = [] }: { people: any[]; devs: any[] } =
        data || {}
      this.noData4 = !people.length && !devs.length
      if (this.noData4) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      let datas: any = []
      let arrTime: any = []
      let arrGzqd: any = []
      let arrCO2: any = []
      let arrVOC: any = []
      this.arrSensorDev = []
      const devss = []
      let index1: any = this.arrSensorDevModel0
      devss.push(devs[index1])
      for (let index: any = 0; index < devs.length; index++) {
        let sensorDev = {
          index: Number,
          value: String,
        }
        sensorDev.index = index
        sensorDev.value = devs[index].devName
        this.arrSensorDev.push(sensorDev)
        if (index === this.arrSensorDevModel0) {
          const element = devs[index].logs
        }
      }
      this.option5 = {
        title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + this.netName + 'PM记录数据曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any[]) {
            let result = ''
            result += params.reduceRight((prev, curr, index) => {
              if (index === params.length - 1) {
                prev += `${formatDate(curr.axisValue)}<br>`
              }
              const r = (prev += `${curr.marker}${curr.seriesName} ${
                UnitControlTypeMap.get(curr.value[2].opeType) || ''
              }${curr.value[1] || '关'}<br>`)
              return r
            }, result)
            return result
          },
        },
        legend: {
          // data: devss.map((item) => item.devName).reverse(),
          data: ['pm1.0', 'pm2.5', 'pm10'],
          itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          textStyle: {
            fontSize: 14,
          },
            width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {
              name: '单元分析',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
        xAxis: {
          type: 'time',
          splitNumber: 24,
          boundaryGap: true,
          min: minTime,
          max: maxTime,
          splitLine: {
            // 网格线
            show: false,
          },
          axisLabel: {
            formatter: function(value: any, index: number) {
              // 格式化成月/日，只在第一个刻度显示年份
              if (value % 3600000) {
                return formatDate(value, 'HH:mm:ss')
              } else {
                return formatDate(value, 'HH:mm')
              }
            },
          },
        },
        yAxis: [
          {
            type: 'value',
            name: '细颗粒物指数',
            min: 0,
            axisLabel: {
              formatter: '{value} μg/m³',
              // color: '#27719F',
            },
          },
        ],
        series: [
          ...devss.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
              defaultSet = '',
            }: { devName: string; logs: any[]; defaultSet: string } = devItem ||
            {}
            return {
              name: 'pm1.0',
              type: 'line',
              step: 'end',
              showSymbol: false,
              connectNulls: false,
              lineStyle: {
                width: 3,
              },
              data: this.getDevSensorPm1LogData(logs, 0, minTime, maxTime),
            }
          }),
          ...devss.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
              defaultSet = '',
            }: { devName: string; logs: any[]; defaultSet: string } = devItem ||
            {}
            // console.log('====' + JSON.stringify(this.getAirLogData(logs, 0, minTime, maxTime)))
            return {
              name: 'pm2.5',
              type: 'line',
              step: 'end',
              showSymbol: false,
              connectNulls: false,
              lineStyle: {
                width: 3,
              },
              data: this.getDevSensorPm2LogData(logs, 0, minTime, maxTime),
            }
          }),
          ...devss.map((devItem: any, index) => {
            const {
              devName = '',
              logs = [],
              defaultSet = '',
            }: { devName: string; logs: any[]; defaultSet: string } = devItem ||
            {}
            // console.log('====' + JSON.stringify(this.getAirLogData(logs, 0, minTime, maxTime)))
            return {
              name: 'pm10',
              type: 'line',
              step: 'end',
              showSymbol: false,
              connectNulls: false,
              lineStyle: {
                width: 3,
              },
              data: this.getDevSensorPm3LogData(logs, 0, minTime, maxTime),
            }
          }),
        ],
      }
      this.options = this.option5
    })
  }
  private getAitQuiltyData(date: any, netId: any,groupId:any) {
    api.getNetDevAirSensorBehavior({ date, netId: netId, groupId: groupId }).then((data) => {
      const { people = [], devs = [] }: { people: any[]; devs: any[] } =
        data || {}
      this.noData4 = !people.length && !devs.length
      // console.log('dev' + JSON.stringify(devs))
      if (this.noData4) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      let datas: any = []
      let arrTime: any = []
      let arrGzqd: any = []
      let arrCO2: any = []
      let arrVOC: any = []
      this.arrSensorDev = []
      const devss = []
      let index1: any = this.arrSensorDevModel0
      devss.push(devs[index1])
      for (let index: any = 0; index < devs.length; index++) {
        let sensorDev = {
          index: Number,
          value: String,
        }
        sensorDev.index = index
        sensorDev.value = devs[index].devName
        this.arrSensorDev.push(sensorDev)
        if (index === this.arrSensorDevModel0) {
          const element = devs[index].logs
          arrCO2 = this.getDevSensorCO2LogData(
            devs[index1].logs,
            0,
            minTime,
            maxTime
          )
          arrVOC = this.getDevSensorVOCLogData(
            devs[index1].logs,
            0,
            minTime,
            maxTime
          )
        }
      }
      this.option6 = {
        title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + this.netName + '室内空气质量记录曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        color: ['#1890ff', '#1f9'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        legend: {
          data: ['VOC', '二氧化碳浓度'],
          selected: {},
          itemGap: 20,
          right: '10%',
            width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
          },
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {
              name: '室内空气质量分析',
            },
          },
        },
        xAxis: [
          {
            type: 'time',
            splitNumber: 24,
            boundaryGap: true,
            min: minTime,
            max: maxTime,
            splitLine: {
              // 网格线
              show: false,
            },
            axisLabel: {
              formatter: function(value: any, index: number) {
                // 格式化成月/日，只在第一个刻度显示年份
                if (value % 3600000) {
                  return formatDate(value, 'HH:mm:ss')
                } else {
                  return formatDate(value, 'HH:mm')
                }
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '二氧化碳浓度',
            position: 'right',
            min: 0,
            axisLabel: {
              formatter: '{value} ppm',
              // color: '#27719F',
            },
            axisPointer: {
              show: true,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // color: '#27719F',
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                // color: '#144463',
              },
            },
          },
          {
            type: 'value',
            name: 'VOC',
            position: 'left',
            axisLabel: {
              formatter: '{value} mg/m3',
              // color: '#27719F',
            },
            min: 0,
            splitLine: {
              show: false,
            },
            axisPointer: {
              show: true,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: true,
              lineStyle: {
                // color: '#27719F',
              },
            },
          },
        ],
        series: [
          {
            type: 'line',
            name: '二氧化碳浓度',
            symbolSize: 3,
            symbol: 'circle',
            barWidth: '12%',
            data: arrCO2,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' },
              ],
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }],
            },
            itemStyle: {
              normal: {
                barBorderRadius: [10, 10, 0, 0],
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: '#42B7FD',
                  },
                  {
                    offset: 1,
                    color: '#42B7FD',
                  },
                ]),
              },
            },
          },
          {
            type: 'line',
            name: 'VOC',
            yAxisIndex: 1,
            itemStyle: {
              color: '#C44D4E',
            },
            symbolSize: 3,
            symbol: 'circle',
            data: arrVOC,
            markPoint: {
              data: [
                { type: 'max', name: '最大值' },
                { type: 'min', name: '最小值' },
              ],
            },
            markLine: {
              data: [{ type: 'average', name: '平均值' }],
            },
          },
        ],
      }
      this.options = this.option6
    })
  }
  private isToday(str: any) {
    var d = new Date(str).setHours(0, 0, 0, 0)
    // console.log(d);
    // console.log( new Date().setHours(0,0,0,0));

    if (d == new Date().setHours(0, 0, 0, 0)) {
      return true
    } else {
      return false
    }
  }
  private format_date(now: any) {
    now = new Date(now)

    var year = now.getFullYear() // 年
    var month = now.getMonth() + 1 // 月
    var day = now.getDate() // 日
    var hh = now.getHours() // 时
    var mm = now.getMinutes() // 分
    var ss = now.getSeconds() // 秒

    var clock = year + '-'
    if (month < 10) {
      clock += '0'
    }
    clock += month + '-'

    if (day < 10) {
      clock += '0'
    }
    clock += day + ' '

    if (hh < 10) {
      clock += '0'
    }
    clock += hh + ':'

    if (mm < 10) {
      clock += '0'
    }
    clock += mm + ':'

    if (ss < 10) {
      clock += '0'
    }
    clock += ss

    return clock
  }

  // 获取插座记录数据
  private getSocketData(date: any, netId: any,groupId:any) {
    api.getSocketBehavior({ date, netId: netId , groupId: groupId }).then((data) => {
      const { devs = [], energy = [] }: { devs: any[]; energy: any[] } =
        data || {}
      this.noData6 = !devs.length
      // console.log('插座记录' + JSON.stringify(devs))
      // console.log('插座记录' + JSON.stringify(energy))
      if (this.noData6) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      const arr = []
      const devss = []
      let powers: any = []
      let energys: any = []
      let index1: any = this.socketDevModel
      devss.push(devs[index1])
      if (devs[index1] !== undefined) {
        for (let index: any = 0; index < devs.length; index++) {
          const obj = { index: Number, devName: String }
          obj['index'] = index
          obj['devName'] = devs[index]['devName']
          arr.push(obj)
        }
        this.socketDev = arr
        powers = this.getSocketPowerData(devs[index1].logs, 0, minTime, maxTime)
        energys = this.getSocketEnergyData(
          energy[index1].logs,
          0,
          minTime,
          maxTime
        )
        // console.log(this.queryParams.date);
        // console.log(this.format_date(new Date()));
        let obj = []
        if (this.isToday(this.queryParams.date)) {
          obj = [
            this.format_date(new Date()),
            energys[energys.length - 1][1],
            {
              ope: energys[energys.length - 1][2],
              time: this.format_date(new Date()),
            },
          ]
          // console.log(obj);
        } else {
          obj = [
            this.format_date(
              new Date(this.queryParams.date).setHours(23, 59, 59, 59)
            ),
            energys[energys.length - 1][1],
            {
              ope: energys[energys.length - 1][2],
              time: this.format_date(
                new Date(this.queryParams.date).setHours(23, 59, 59, 59)
              ),
            },
          ]
        }

        //  if()

        // let obj=["2022-04-15 23:00:00",3.38,{ope:3.38,time:'2022-04-14 24:00:00'}

        // ]
        energys.push(obj)
        //  console.log(powers);
        //  console.log(energys);

        this.option7 = {
          title: {
            textStyle: {
              color: '#333',
              fontStyle: 'normal',
              fontWeight: '200',
              fontFamily: 'sans-serif',
              fontSize: 15,
            },
            text: date + '日' + this.netName + '插座行为记录曲线图',
            x: 'center',
            y: 'bottom',
            padding: [100, 0, 0, 0],
          },
          color: ['#1890ff', '#1f9'],
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true,
          },
          legend: {
            data: ['功率', '电量'],
            selected: {},
            itemGap: 20,
            right: '10%',
              width:"80%",
          
          selector: ['all', 'inverse'] ,//全选和反选按钮
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
            },
          },
          dataZoom: [
            {
              type: 'inside',
              filterMode: 'none',
              throttle: 50,
            },
          ],

          toolbox: {
            feature: {
              dataZoom: {
                yAxisIndex: 'none',
              },
              restore: {},
              saveAsImage: {
                name: '单元分析',
              },
            },
          },
          xAxis: [
            {
              type: 'time',
              splitNumber: 24,
              boundaryGap: true,
              min: minTime,
              max: maxTime,
              splitLine: {
                // 网格线
                show: false,
              },
              axisLabel: {
                formatter: function(value: any, index: number) {
                  // 格式化成月/日，只在第一个刻度显示年份
                  if (value % 3600000) {
                    return formatDate(value, 'HH:mm:ss')
                  } else {
                    return formatDate(value, 'HH:mm')
                  }
                },
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              name: '电量',
              position: 'right',
              min: 0,
              axisLabel: {
                formatter: '{value}Wh',
                // color: '#27719F',
              },
              axisPointer: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  // color: '#27719F',
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  // color: '#144463',
                },
              },
            },
            {
              type: 'value',
              name: '功率',
              position: 'left',
              axisLabel: {
                formatter: '{value} W',
                // color: '#27719F',
              },
              splitLine: {
                show: false,
              },
              axisPointer: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  // color: '#27719F',
                },
              },
            },
          ],
          series: [
            {
              type: 'line',
              name: '电量',
              // step: 'end',
              symbolSize: 3,
              symbol: 'circle',
              barWidth: '12%',
              data: energys,
              itemStyle: {
                normal: {
                  barBorderRadius: [10, 10, 0, 0],
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: '#42B7FD',
                    },
                    {
                      offset: 1,
                      color: '#42B7FD',
                    },
                  ]),
                },
              },
            },
            {
              type: 'line',
              name: '功率',
              step: 'end',
              yAxisIndex: 1,
              itemStyle: {
                color: '#C44D4E',
              },
              symbolSize: 3,
              symbol: 'circle',
              data: powers,
            },
          ],
        }
      }
    })
  }
    // 获取调光记录数据
  private getDimmerData(date: any, netId: any) {
    api.netAdjustSwitch({ date, netId: netId }).then((data) => {
      console.log(data);
      
      // const { devs = [], energy = [] }: { devs: any[]; energy: any[] } =
      //   data || {}
      let devs = data.devs
      let switchs = data.switchs
      this.noData8 = !devs.length
      // console.log('插座记录' + JSON.stringify(devs))
      // console.log('插座记录' + JSON.stringify(energy))
      if (this.noData8) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      const arr = []
      const devss = []
      let powers: any = []
      let energys: any = []
      let index1: any = this.dimmerDevModel
      devss.push(devs[index1])
      if (devs[index1] !== undefined) {
        for (let index: any = 0; index < devs.length; index++) {
          const obj = { index: Number, devName: String }
          obj['index'] = index
          obj['devName'] = devs[index]['devName']
          arr.push(obj)
        }
        this.dimmerDev= arr
        let fatherid=devs[index1].fatherDevId
        let fathername=devs[index1].fatherDevName
        let logsAd=[]
        if(switchs[fatherid]!==undefined){
       logsAd=switchs[fatherid].logs||[]


        }
       energys  = this.getDimmerPowerData(devs[index1].logs, 0, minTime, maxTime)
        powers = this.getDimmertEnergyData(
          logsAd,
          0,
          minTime,
          maxTime
        )
        console.log(powers);
        
        // console.log(this.queryParams.date);
        // console.log(this.format_date(new Date()));
        let obj = []
        if (this.isToday(this.queryParams.date)) {
          obj = [
            this.format_date(new Date()),
            energys[energys.length - 1][1],
            {
              ope: energys[energys.length - 1][2].ope,
              time: this.format_date(new Date()),
            },
          ]
          // console.log(obj);
        } else {
          obj = [
            this.format_date(
              new Date(this.queryParams.date).setHours(23, 59, 59, 59)
            ),
            energys[energys.length - 1][1],
            {
              ope: energys[energys.length - 1][2],
              time: this.format_date(
                new Date(this.queryParams.date).setHours(23, 59, 59, 59)
              ),
            },
          ]
        }

        //  if()

        // let obj=["2022-04-15 23:00:00",3.38,{ope:3.38,time:'2022-04-14 24:00:00'}

        // ]
        energys.push(obj)
        //  console.log(powers);
        //  console.log(energys);

        this.option9 = {
          title: {
            textStyle: {
              color: '#333',
              fontStyle: 'normal',
              fontWeight: '200',
              fontFamily: 'sans-serif',
              fontSize: 15,
            },
            text: date + '日' + this.netName + '调光器行为记录曲线图',
            x: 'center',
            y: 'bottom',
            padding: [100, 0, 0, 0],
          },
          color: ['#1890ff', '#1f9'],
          grid: {
            left: '3%',
            right: '4%',
            bottom: '10%',
            containLabel: true,
          },
          legend: {
            data: ['调光器所属开关状态', '调光器亮度'],
            selected: {},
            itemGap: 20,
            right: '10%',
              width:"80%",
          
          // selector: ['all', 'inverse'] ,//全选和反选按钮
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
            },
              formatter: function (params) {
                console.log('x');
                
            console.log( params[0]);
            
            // 假设你想加上的字段名为 'extraField'
            // var extraField = '额外信息';
            var seriesName = params[0].seriesName; // 系列名称
            var time=formatDate(params[0].value[0],'YYYY-MM-DD HH:mm:ss');
            // var seriesName2 = params[1].seriesName; // 系列名称
            let ope=params[0].value[2].ope;
            let ope2=params[0].value[2].ope;
            if(seriesName=='所属开关状态'){
             ope=params[0].value[2].ope=='2'?'开':'关'
             ope2=params[0].value[2].ope=='2'?'开':'关'

            }else{
              // if(params[0].value[2].ope){

              // }
              if(params[0].value[2].ope.split('=')[1]){
                 ope=(params[0].value[2].ope.split('=')[1]/255*100).toFixed(2)+'%'
                 ope2=(params[0].value[2].ope.split('=')[0]/255*100).toFixed(2)+'%'


              }
              else{
                ope='0%'
                ope2='0%'

              }
             
            }

            return  time+'<br/>'+seriesName+':'+ope+'<br/>'+'色温'+':'+ope2+'<br/>'+'所属开关:'+fathername ;
        }
          },
          dataZoom: [
            {
              type: 'inside',
              filterMode: 'none',
              throttle: 50,
            },
          ],

          toolbox: {
            feature: {
              dataZoom: {
                yAxisIndex: 'none',
              },
              restore: {},
              saveAsImage: {
                name: '单元分析',
              },
            },
          },
          xAxis: [
            {
              type: 'time',
              splitNumber: 24,
              boundaryGap: true,
              min: minTime,
              max: maxTime,
              splitLine: {
                // 网格线
                show: false,
              },
              axisLabel: {
                formatter: function(value: any, index: number) {
                  // 格式化成月/日，只在第一个刻度显示年份
                  if (value % 3600000) {
                    return formatDate(value, 'HH:mm:ss')
                  } else {
                    return formatDate(value, 'HH:mm')
                  }
                },
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              name: '亮度',
              position: 'right',
              min: 0,
              axisLabel: {
                formatter: '{value}%',
                // color: '#27719F',
              },
              axisPointer: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  // color: '#27719F',
                },
              },
              splitLine: {
                show: true,
                lineStyle: {
                  // color: '#144463',
                },
              },
            },
            {
              type: 'value',
            
              position: 'left',
              axisLabel: {
                // formatter: '{value} ',
                show:false,
                // color: '#27719F',
              },
                max: 3,
              splitLine: {
                show: false,
              },
              axisPointer: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              axisLine: {
                show: false,
                // lineStyle: {
                //   // color: '#27719F',
                // },
              },
            },
          ],
          series: [
            {
              type: 'line',
              name: '亮度',
              // step: 'end',
              symbolSize: 3,
              symbol: 'circle',
              barWidth: '12%',
              data: energys,
              itemStyle: {
                normal: {
                  barBorderRadius: [10, 10, 0, 0],
                  color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: '#42B7FD',
                    },
                    {
                      offset: 1,
                      color: '#42B7FD',
                    },
                  ]),
                },
              },
            },
            {
              type: 'line',
              name: '所属开关状态',
              step: 'end',
           
              yAxisIndex: 1,
              itemStyle: {
                color: '#C44D4E',
              },
              symbolSize: 3,
              symbol: 'circle',
              data: powers,
            },
          ],
        }
      }
    })
  }

  private getWearthData(date:any){
    api.getWeather({ date,orgId:UserModule.orgInfo.orgId }).then((data) => {
console.log(data);
let list=data

  
 


  this.noData7 = !list[0].log.length
  this.option8 =null
    if (this.noData7) return
    this.wearthDev = list
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
     
  console.log(list);
    let arr = []
   
    let index1: any = this.wearthModel
    console.log(index1);
    
    for (let index: any = 0; index < list.length; index++) {

      if(list[index].type==index1){
        arr=list[index]
      }
    }
    console.log(arr);
    let devtype=[]
    for(let i=0;i<arr.log[0].child.length;i++){
      devtype.push(arr.log[0].child[i].childtext)


    }
    console.log(devtype);
    if(index1=='template'){
    
    
    
  
  this.option8 = {
    title: {
      textStyle: {
        color: '#333',
        fontStyle: 'normal',
        fontWeight: '200',
        fontFamily: 'sans-serif',
        fontSize: 15,
      },
      text: date + '日天气记录曲线图',
      x: 'center',
      y: 'bottom',
      padding: [100, 0, 0, 0],
    },
    color: ['#1890ff', '#1f9'],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%',
      containLabel: true,
    },
    legend: {
      data:devtype,
     itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          textStyle: {
            fontSize: 14,
          },
      width:"80%",
      // selector: ['all', 'inverse'] ,//全选和反选按钮
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
      },
          formatter: function (params) {
            // console.log( params[0],params[1]);
            
            // 假设你想加上的字段名为 'extraField'
            // var extraField = '额外信息';
            // var seriesName = params[0].seriesName; // 系列名称
            // var seriesName2 = params[1].seriesName; // 系列名称

            return params[0].value[0]+'<br/>'+ '相对湿度：' +  params[0].value[1] + '%<br/>' +'室外温度：' +  params[1].value[1]+'℃<br/>' +'天气现象：' +  params[1].value[2].child[0].weather;
        }
 
    
    },
    dataZoom: [
      {
        type: 'inside',
        filterMode: 'none',
        throttle: 50,
      },
    ],
    toolbox: {
      feature: {
        dataZoom: {
          yAxisIndex: 'none',
        },
        restore: {},
        saveAsImage: {
          name: '天气分析',
        },
      },
    },
    xAxis: [
      {
        type: 'time',
        splitNumber: 24,
        boundaryGap: true,
        min: minTime,
        max: maxTime,
        splitLine: {
          // 网格线
          show: false,
        },
        axisLabel: {
          formatter: function(value: any, index: number) {
            // 格式化成月/日，只在第一个刻度显示年份
            if (value % 3600000) {
              return formatDate(value, 'HH:mm:ss')
            } else {
              return formatDate(value, 'HH:mm')
            }
          },
        },
      },
    ],
    yAxis: [
              {
                type: 'value',
                name: '湿度',
                position: 'right',
                min: 0,
                axisLabel: {
                  formatter: '{value}%',
                  // color: '#27719F',
                },
                axisPointer: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    // color: '#27719F',
                  },
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    // color: '#144463',
                  },
                },
              },
              {
                type: 'value',
                name: '温度',
                position: 'left',
                axisLabel: {
                  formatter: '{value} ℃',
                  // color: '#27719F',
                },
                max:60,
                splitLine: {
                  show: false,
                },
                axisPointer: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    // color: '#27719F',
                  },
                },
              },
            ],


                  series: [
              {
                type: 'line',
                name: '湿度',
                symbolSize: 3,
                symbol: 'circle',
                barWidth: '12%',
                data: this.getweatherDataLogData(
                 arr.log,
                  'humidity',
                  minTime,
                  maxTime
                ),
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                markLine: {
                  data: [{ type: 'average', name: '平均值' }],
                },
                itemStyle: {
                  normal: {
                    barBorderRadius: [10, 10, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                      {
                        offset: 0,
                        color: '#42B7FD',
                      },
                      {
                        offset: 1,
                        color: '#42B7FD',
                      },
                    ]),
                  },
                },
              },
              {
                type: 'line',
                name: '温度',
                yAxisIndex: 1,
                itemStyle: {
                  color: '#C44D4E',
                },
                symbolSize: 3,
                symbol: 'circle',
                data: this.getweatherDataLogData(
                  arr.log,
                  'temperature',
                  minTime,
                  maxTime
                ),
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                markLine: {
                  data: [{ type: 'average', name: '平均值' }],
                },
              },
            ],
    }
    }
    if(index1=='pm'){
        this.option8 = {
    title: {
      textStyle: {
        color: '#333',
        fontStyle: 'normal',
        fontWeight: '200',
        fontFamily: 'sans-serif',
        fontSize: 15,
      },
      text: date + '日天气记录曲线图',
      x: 'center',
      y: 'bottom',
      padding: [100, 0, 0, 0],
    },
    color: ['#1890ff', '#1f9'],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%',
      containLabel: true,
    },
    legend: {
      data:devtype,
     itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          textStyle: {
            fontSize: 14,
          },
      width:"80%",
      // selector: ['all', 'inverse'] ,//全选和反选按钮
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
      },
    },
    dataZoom: [
      {
        type: 'inside',
        filterMode: 'none',
        throttle: 50,
      },
    ],
    toolbox: {
      feature: {
        dataZoom: {
          yAxisIndex: 'none',
        },
        restore: {},
        saveAsImage: {
          name: '天气分析',
        },
      },
    },
    xAxis: [
      {
        type: 'time',
        splitNumber: 24,
        boundaryGap: true,
        min: minTime,
        max: maxTime,
        splitLine: {
          // 网格线
          show: false,
        },
        axisLabel: {
          formatter: function(value: any, index: number) {
            // 格式化成月/日，只在第一个刻度显示年份
            if (value % 3600000) {
              return formatDate(value, 'HH:mm:ss')
            } else {
              return formatDate(value, 'HH:mm')
            }
          },
        },
      },
    ],
    yAxis: [
              {
                type: 'value',
                name: 'PM2.5',
                position: 'right',
                min: 0,
                axisLabel: {
                  formatter: '{value}μg/m³',
                  // color: '#27719F',
                },
                axisPointer: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    // color: '#27719F',
                  },
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    // color: '#144463',
                  },
                },
              },
              {
                type: 'value',
                name: 'PM10',
                position: 'left',
                axisLabel: {
                  formatter: '{value}μg/m³',
                  // color: '#27719F',
                },
                 min: 0,
                splitLine: {
                  show: false,
                },
                axisPointer: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    // color: '#27719F',
                  },
                },
              },
            ],


                  series: [
              {
                type: 'line',
                name: 'PM2.5',
                symbolSize: 3,
                symbol: 'circle',
                barWidth: '12%',
                data: this.getweatherDataLogData(
                 arr.log,
                  'pm2',
                  minTime,
                  maxTime
                ),
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                markLine: {
                  data: [{ type: 'average', name: '平均值' }],
                },
                itemStyle: {
                  normal: {
                    barBorderRadius: [10, 10, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                      {
                        offset: 0,
                        color: '#42B7FD',
                      },
                      {
                        offset: 1,
                        color: '#42B7FD',
                      },
                    ]),
                  },
                },
              },
              {
                type: 'line',
                name: 'PM10',
                yAxisIndex: 1,
                itemStyle: {
                  color: '#C44D4E',
                },
                symbolSize: 3,
                symbol: 'circle',
                data: this.getweatherDataLogData(
                  arr.log,
                  'pm10',
                  minTime,
                  maxTime
                ),
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                markLine: {
                  data: [{ type: 'average', name: '平均值' }],
                },
              },
            ],
    }
    }
    if(index1=='wind'){
        this.option8 = {
    title: {
      textStyle: {
        color: '#333',
        fontStyle: 'normal',
        fontWeight: '200',
        fontFamily: 'sans-serif',
        fontSize: 15,
      },
      text: date + '日天气记录曲线图',
      x: 'center',
      y: 'bottom',
      padding: [100, 0, 0, 0],
    },
    color: ['#1890ff', '#1f9'],
    grid: {
      left: '3%',
      right: '4%',
      bottom: '10%',
      containLabel: true,
    },
    legend: {
      data:devtype,
     itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          textStyle: {
            fontSize: 14,
          },
      width:"80%",
      // selector: ['all', 'inverse'] ,//全选和反选按钮
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'cross',
      },
    },
    dataZoom: [
      {
        type: 'inside',
        filterMode: 'none',
        throttle: 50,
      },
    ],
    toolbox: {
      feature: {
        dataZoom: {
          yAxisIndex: 'none',
        },
        restore: {},
        saveAsImage: {
          name: '天气分析',
        },
      },
    },
    xAxis: [
      {
        type: 'time',
        splitNumber: 24,
        boundaryGap: true,
        min: minTime,
        max: maxTime,
        splitLine: {
          // 网格线
          show: false,
        },
        axisLabel: {
          formatter: function(value: any, index: number) {
            // 格式化成月/日，只在第一个刻度显示年份
            if (value % 3600000) {
              return formatDate(value, 'HH:mm:ss')
            } else {
              return formatDate(value, 'HH:mm')
            }
          },
        },
      },
    ],
    yAxis: [
              {
                type: 'value',
                name: '风力等级',
                position: 'left',
                max: 20,
                axisLabel: {
                  formatter: '{value}级',
                  // color: '#27719F',
                },
                axisPointer: {
                  show: true,
                },
                axisTick: {
                  show: false,
                },
                axisLine: {
                  show: true,
                  lineStyle: {
                    // color: '#27719F',
                  },
                },
                splitLine: {
                  show: true,
                  lineStyle: {
                    // color: '#144463',
                  },
                },
              },
          
            ],


                  series: [
              {
                type: 'line',
                name: '风力等级',
                symbolSize: 3,
                symbol: 'circle',
                barWidth: '12%',
                data: this.getweatherDataLogData(
                 arr.log,
                  'wind',
                  minTime,
                  maxTime
                ),
                markPoint: {
                  data: [
                    { type: 'max', name: '最大值' },
                    { type: 'min', name: '最小值' },
                  ],
                },
                markLine: {
                  data: [{ type: 'average', name: '平均值' }],
                },
                itemStyle: {
                  normal: {
                    barBorderRadius: [10, 10, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                      {
                        offset: 0,
                        color: '#42B7FD',
                      },
                      {
                        offset: 1,
                        color: '#42B7FD',
                      },
                    ]),
                  },
                },
              },
            
            ],
    }
    }


      })
   
 









  }
  private wearthRadioChange(){
    this.getData()
  }
  
  private getRebootMarkPoints(logResult: any[]) {
    return logResult
      .filter(item => item[2] && item[2].isReboot)
      .map(item => ({
        coord: [item[0], item[1]],
        symbol: 'rect',
        symbolSize: 8,
        itemStyle: {
          color: '#ff0000'
        }
      }))
  }

 private getDevLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult = logs.map((item: any) => [
      item.time,
      item.ope + baseVal,
      item,
    ])
   
    if (logs[0] && new Date(logs[0].time) > minTime) {
      let open = Number(logs[0].ope)
      logResult.unshift([minTime, open + baseVal, logs[0]])
    }
    if (
      logs[logs.length - 1] &&
      new Date(logs[logs.length - 1].time) < maxTime
    ) {
      let open = logs[logs.length - 1].ope
      if (maxTime > Date.now()) {
        logResult.push([Date.now(), open + baseVal, logs[logs.length - 1]])
      } else {
        logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
      }
    }

    for (let i = 0; i < logResult.length; i++) {
      if (i == 0) {
        if (logResult[i][2].opeType == 'power'||logResult[i][2].opeType == 'gatewaymesh') {
          logResult[i][2].opeType = 'people'
          logResult[i][2].ope = 0
          if (
            logs[logs.length - 1] &&
            new Date(logs[logs.length - 1].time) < maxTime
          ) {
            let open = logs[logs.length - 1].ope
            if (maxTime > Date.now()) {
              logResult.push([
                Date.now(),
                open + baseVal,
                logs[logs.length - 1],
              ])
            } else {
              logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
            }
          }
        }
      }

      if(i==(logResult.length-1)){
        if (logResult[i][2].opeType == 'power'||logResult[i][2].opeType == 'gatewaymesh') {
          logResult[i][2].opeType = 'people'
          logResult[i][2].ope = 0
          if (
            logs[logs.length - 1] &&
            new Date(logs[logs.length - 1].time) < maxTime
          ) {
            let open = logs[logs.length - 1].ope
            if (maxTime > Date.now()) {
              logResult.push([
                Date.now(),
                open + baseVal,
                logs[logs.length - 1],
              ])
            } else {
              logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
            }
          }
        }
      }

      if (logResult[i][2].opeType == 'nativepeople') {
        if (i == 0) {
          logResult[i][1] = logResult[i + 1][1]
        } else {
          logResult[i][1] = logResult[i - 1][1]
        }
      }

      if (logResult[i][2].opeType == 'reboot') {
        logResult[i][2].isReboot = true
        if (i > 0) {
          let prevIndex = i - 1
          while (prevIndex >= 0 && logResult[prevIndex][2].opeType == 'reboot') {
            prevIndex--
          }
          if (prevIndex >= 0) {
            logResult[i][1] = logResult[i - 1][1]
          } else {
            logResult[i][1] = baseVal
          }
        } else {
          logResult[i][1] = baseVal
        }
      }

      if (logResult[i][2].opeType == 'sensitivity') {
        logResult.splice(i, 1)
        i--
      }

      if (logResult[i] && logResult[i][2].opeType == 'gatewaymesh') {
        if (i == 0) {
          logResult[i][1] = logResult[i + 1][1]
        } else {
          logResult[i][1] = logResult[i - 1][1]
        }
      }
    }

    let x = logResult.length
    while (x--) {
      if (logResult[x][2].opeType == 'power'||logResult[x][2].opeType == 'sensitivity'||logResult[x][2].opeType == 'valve') {
        logResult.splice(x, 1)
      }
    }

    return logResult
  }
   private getDevsunshadeLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {


  let logResult = logs.map((item) => {

    let devActExplain=item.devActExplain||''
    let xta = String(100 - parseFloat(devActExplain.split('=')[1])).split('%')[0] / 100 || item.ope
    // console.log(xta);
    return [
      item.time,
      xta + baseVal,
      item,
    ]

  })

  if (logs[0] && new Date(formatDate(logs[0].time, 'yyyy/MM/dd HH:mm:ss')) > minTime) {
    let open = Number(logs[0].ope.split('=')[1])
    logResult.unshift([minTime, open + baseVal, logs[0]])
  }
  if (
    logs[logs.length - 1] &&
    new Date(logs[logs.length - 1].time) < maxTime
  ) {
    let open = logs[logs.length - 1].ope
    /** 如果最大值大于今天的日期，只接受当前时间 */
    if (maxTime > Date.now()) {
      logResult.push([Date.now(), open + baseVal, logs[logs.length - 1]])
    } else {
      logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
    }
  }
  // // console.log(logResult);
  for (let i = 0; i < logResult.length; i++) {
    if (i == 0) {
      if (logResult[i][2].opeType == 'power' || logResult[i][2].opeType == 'gatewaymesh') {
        logResult[i][2].opeType = 'people'
        logResult[i][2].ope = 0
        if (
          logs[logs.length - 1] &&
          new Date(logs[logs.length - 1].time) < maxTime
        ) {
          let open = logs[logs.length - 1].ope
          /** 如果最大值大于今天的日期，只接受当前时间 */
          if (maxTime > Date.now()) {
            logResult.push([
              Date.now(),
              open + baseVal,
              logs[logs.length - 1],
            ])
          } else {
            logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
          }
        }

        // // console.log(logResult[i]);
      }

    }
    if (i == (logResult.length - 1)) {
      if (logResult[i][2].opeType == 'power' || logResult[i][2].opeType == 'gatewaymesh') {
        logResult[i][2].opeType = 'people'
        logResult[i][2].ope = 0
        if (
          logs[logs.length - 1] &&
          new Date(logs[logs.length - 1].time) < maxTime
        ) {
          let open = logs[logs.length - 1].ope
          /** 如果最大值大于今天的日期，只接受当前时间 */
          if (maxTime > Date.now()) {
            logResult.push([
              Date.now(),
              open + baseVal,
              logs[logs.length - 1],
            ])
          } else {
            logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
          }
        }

        // // console.log(logResult[i]);
      }

    }
    if (logResult[i][2].opeType == 'nativepeople') {
      // // console.log(logResult);
      if (i == 0) {
        logResult[i][1] = logResult[i + 1][1]
      } else {
        logResult[i][1] = logResult[i - 1][1]
      }
    }
    if (logResult[i][2].opeType == 'sensitivity') {
      // // console.log(logResult);
      logResult.splice(i, 1)
      // if (i == 0) {
      //   logResult[i][1] = logResult[i + 1][1]
      // } else {
      //   logResult[i][1] = logResult[i - 1][1]
      // }
    }
    if (logResult[i][2].opeType == 'gatewaymesh') {
      // // console.log(logResult);
      //  logResult[i][2].ope=0
      if (i == 0) {
        logResult[i][1] = logResult[i + 1][1]
      } else {
        logResult[i][1] = logResult[i - 1][1]
      }

    }

  }
  //  for(let i=0;i<logResult.length;i++){
  //   if(logResult[i][2].opeType=='power'){
  //     logResult.splice(i--,1)
  //     // // console.log(logResult[i]);

  //   }
  //  }

  // // console.log(logResult);
  let x = logResult.length
  while (x--) {
    if (logResult[x][2].opeType == 'power' || logResult[x][2].opeType == 'sensitivity') {
      logResult.splice(x, 1)
    }
  }



  return logResult
}


  private getAirLogData1(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {

    // console.log('zxc',logs);
    
    let logResult = logs.map((item: any) =>{ 
      let result = []
      let ope=0
      if (item.opeType.indexOf('valve') != -1) {
      //  ope=parseInt(item.ope.split('=')[0]) +baseVal
      //   result=[item.time,ope,item]

      }else{
        ope=item.ope.indexOf('close') != -1?0+baseVal:1+baseVal
        if(item.opeType.indexOf('close')!=-1){
          ope=0+baseVal
        }
        result=[item.time,ope,item]
      


      }
      
      return result




    })
    //数组去空
    logResult = logResult.filter(item => item.length > 0)


    
    //数组去重
    let newArr=[]
    for(let i=0;i<logResult.length;i++){
      let flag=false
      for(let j=0;j<newArr.length;j++){
        if(newArr[j][0]==logResult[i][0]){
          flag=true
          break
        }
      }
      if(!flag){
        newArr.push(logResult[i])
      }
    }
    logResult=newArr

    
      //补最后一条到当前时间的数据
      if(logResult.length>0){
      let list=[new Date().toISOString(),logResult[logResult.length-1][1],logResult[logResult.length-1][2]]
      logResult.push(list)
    }
    //      let list=[new Date().toISOString(),logResult[logResult.length-1][1],logResult[logResult.length-1][2]]
    // logResult.push(list)
  
    // //补一条0点的数据
    // let list=[0,logResult[0][1],logResult[0][2]]
    // logResult.unshift(list)
   
    
   
    // if (logs[0] && new Date(logs[0].time) > minTime) {
    //   let open = Number(logs[0].ope)
    //   logResult.unshift([minTime, open + baseVal, logs[0]])
    // }
    // if (
    //   logs[logs.length - 1] &&
    //   new Date(logs[logs.length - 1].time) < maxTime
    // ) {
    //   let open = logs[logs.length - 1].ope
    //   /** 如果最大值大于今天的日期，只接受当前时间 */
    //   if (maxTime > Date.now()) {
    //     logResult.push([Date.now(), open + baseVal, logs[logs.length - 1]])
    //   } else {
    //     logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
    //   }
    // }
    // console.log('csz',logResult);
    
   
  

    return logResult
  }

  private getAirLogData2(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {

    // console.log('zxc',logs);
    
    let logResult = logs.map((item: any) =>{ 
      let result = []
      let ope=0
      if (item.opeType.indexOf('valve') != -1) {
       ope=parseInt(item.ope.split('=')[0]) +baseVal
        result=[item.time,ope,item]

      }else{
        // ope=item.ope.indexOf('close') != -1?0+baseVal:1+baseVal
        // result=[item.time,ope,item]
      


      }

   
      
      return result




    })
    //数组去空
    logResult = logResult.filter(item => item.length > 0)


    //数组去重
    let newArr=[]
    for(let i=0;i<logResult.length;i++){
      let flag=false
      for(let j=0;j<newArr.length;j++){
        if(newArr[j][0]==logResult[i][0]){
          flag=true
          break
        }
      }
      if(!flag){
        newArr.push(logResult[i])
      }
    }
    logResult=newArr
    // console.log('csz',logResult);
    
    //补最后一条到当前时间的数据
    if(logResult.length>0){
      let list=[new Date().toISOString(),logResult[logResult.length-1][1],logResult[logResult.length-1][2]]
      logResult.push(list)
    }

    
  




    // //补一条0点的数据
    // let list=[0,logResult[0][1],logResult[0][2]]
    // logResult.unshift(list)
   
    
   
    // if (logs[0] && new Date(logs[0].time) > minTime) {
    //   let open = Number(logs[0].ope)
    //   logResult.unshift([minTime, open + baseVal, logs[0]])
    // }
    // if (
    //   logs[logs.length - 1] &&
    //   new Date(logs[logs.length - 1].time) < maxTime
    // ) {
    //   let open = logs[logs.length - 1].ope
    //   /** 如果最大值大于今天的日期，只接受当前时间 */
    //   if (maxTime > Date.now()) {
    //     logResult.push([Date.now(), open + baseVal, logs[logs.length - 1]])
    //   } else {
    //     logResult.push([maxTime, open + baseVal, logs[logs.length - 1]])
    //   }
    // }
    // console.log('csz',logResult);
    
   
  

    return logResult
  }

  
  private getAirLogData3(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    // return   data: [
            //     // 这里填写风机的开始和结束时间数据
            //     [1, '2024-12-12T09:15:10.000+0800', '2024-12-12T09:50:10.000+0800','#57E099'], //开始时间和结束时间
            //     [1, '2024-12-12T10:15:10.000+0800', '2024-12-12T15:15:10.000+0800', '#FFA500'],
            //     [1, '2024-12-12T16:15:10.000+0800', '2024-12-12T16:50:10.000+0800', '#FF6347'],
            //     // 继续添加更多数据...
            // ],

    //输出格式  [1, '2024-12-12T09:15:10.000+0800', '2024-12-12T09:50:10.000+0800','#57E099'],

    // //logs 去重
    let newArr1=[]
    for(let i=0;i<logs.length;i++){
      let flag=false
      for(let j=0;j<newArr1.length;j++){
        if(newArr1[j].time==logs[i].time){
          flag=true
          break
        }
      }
      if(!flag){
        newArr1.push(logs[i])
      }
    }
    logs=newArr1

let newArr=[]

    let logResult=[]



    for(let i=0;i<logs.length;i++){
      if(logs[i].opeType.indexOf('valve') != -1){
        newArr.push(logs[i])
      }
    }
    for(let i=0;i<newArr.length;i++){




        let result = []
        let ope=parseInt(newArr[i].ope.split('=')[1])
        let time=newArr[i+1]
        if(time){
          time=time.time


        }else{
          time=newArr[i].time
        }
        if(i==newArr.length-1){
          //最后一条补3s

          time=new Date().toISOString()

          // time=newArr[i].time
        }
        if(ope==1){
          result=[1,newArr[i].time,time,'#b7dfbf',ope]

        }
        // if(ope==0){
        //   result=[1,logs[i].time,logs[i+1].time,'#FFA500']
        //   }
          if(ope==2){
          result=[1,newArr[i].time,time,'#58d466',ope]
          }
          if(ope==3){
            result=[1,newArr[i].time,time,'#3b7c47',ope]
          }
         




      
        logResult.push(result)
      
    }

     //数组去空
     logResult = logResult.filter(item => item.length > 0)

     
    // //数组去重
    // let newArr=[]
    // for(let i=0;i<logResult.length;i++){
    //   let flag=false
    //   for(let j=0;j<newArr.length;j++){
    //     if(newArr[j][0]==logResult[i][0]){
    //       flag=true
    //       break
    //     }
    //   }
    //   if(!flag){
    //     newArr.push(logResult[i])
    //   }
    // }
    // logResult=newArr


  console.log('12344',logResult);
  

    return logResult
  }

  private getDevbjData(dataarr: any[]) {
    // console.log(dataarr);
    let data = []

    for (let i = 0; i < dataarr.length; i++) {
      if (dataarr[i][2].opeType == 'nativepeople' && dataarr[i][2].ope == '1') {
        let obj = {
          name: '某个坐标',
          yAxis: dataarr[i][1],
          xAxis: dataarr[i][0],
          value: '',
        }

        data.push(obj)
      }
    }
    // console.log(data);

    return data
  }

  private getDevbjDatanoman(dataarr: any[]) {
    // console.log(dataarr);
    let data = []

    for (let i = 0; i < dataarr.length; i++) {
      if (dataarr[i][2].opeType == 'nativepeople' && dataarr[i][2].ope == '0') {
        let obj = {
          name: '某个坐标',
          yAxis: dataarr[i][1],
          xAxis: dataarr[i][0],
          value: '',
        }

        data.push(obj)
      }
    }
    // console.log(data);

    return data
  }

  private getAirLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    const idx = this.arrAirDevModel
    let logResult = logs.map((item: any) => {
     

    
      if (item.ope.indexOf('close') != -1) {
        item.wendu = 0
        return [item.time, item.wendu, item]
      } else {
        return [item.time, item.wendu, item]
      }
        
    })
    // console.log(logResult)

    if (logs[0] && new Date(logs[0].time) > minTime) {
      let wendu = Number(logs[0].wendu)
      if (logs[0].ope.indexOf('close') != -1) {
        wendu = 0
      }
      logResult.unshift([minTime, 0, logs[0]])
    }
    if (
      logs[logs.length - 1] &&
      new Date(logs[logs.length - 1].time) < maxTime
    ) {
      let wendu = logs[logs.length - 1].wendu
      // console.log(logs[logs.length - 1].ope.indexOf('close'));
      if (logs[logs.length - 1].ope.indexOf('close') != -1) {
        wendu = 0
      }
      /** 如果最大值大于今天的日期，只接受当前时间 */
      if (maxTime > Date.now()) {
        logResult.push([Date.now(), wendu, logs[logs.length - 1]])
      } else {
        logResult.push([maxTime, wendu, logs[logs.length - 1]])
      }
    }
     let x = logResult.length

     while (x--) {
      if (logResult[x][2].opeType == 'valve') {
        logResult.splice(x, 1)
      }
    }
    return logResult
  }
  private getSocketPowerData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      logResult.push([
        logs[index].time,
        (Number(logs[index].ope) / 1000).toFixed(2),
        logs[index],
      ])
    }
    return logResult
  }
  private getDimmerPowerData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      // console.log(logs[index]);
      if(logs[index].ope.toString().indexOf('=')!=-1){

      
      
      logResult.push([
        logs[index].time,
        (((logs[index].ope).toString().split('=')[1]) / 255).toFixed(2)*100,
        logs[index],
      ])
    }
    }
    return logResult
  }
   private getDimmertEnergyData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      // console.log(logs[index]);
      
      logResult.push([
        logs[index].time,
        (logs[index].ope).toString().indexOf('close')==-1?'2':'1',
        logs[index],
      ])
    }
    return logResult
  }
  
  private getSocketEnergyData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      logResult.push([logs[index].time, Number(logs[index].ope), logs[index]])
    }
    return logResult
  }

  private getDevSensorWenduLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope === 0) {
        // logResult.push([logs[index].time, Number(logs[index].ope), logs[index]])
      } else {
           if (Number(logs[index].ope.split(':')[0]) !== 0&&Number(logs[index].ope.split(':')[0])<60) {
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[0]).toFixed(1),
            logs[index],
          ])
        }
        //     if (Number(logs[index].ope.split(':')[0])== 0&&Number(logs[index].ope.split(':')[1])== 0&&Number(logs[index].ope.split(':')[2])== 0) {
        //   logResult.push([
        //     logs[index].time,
        //     Number(logs[index].ope.split(':')[0]),
        //     logs[index],
        //   ])
        // }
        // logResult.push([
        //   logs[index].time,
        //   Number(logs[index].ope.split(':')[0]),
        //   logs[index],
        // ])
      }
    }
    console.log(logResult);
    //计算其中一个设备的平均值
    let sum = 0
    let count = 0
    for (let i = 0; i < logResult.length; i++) {
     
        sum += Number(logResult[i][1])
        count++
      
    }
    if (count > 0) {
      let avg = sum / count
      console.log(avg);
    }

    
    return logResult
  }

   private getweatherDataLogData(
    logs: any[],
    type: any,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
     for(let i=0;i<logs[index].child.length;i++){
     if(logs[index].child[i].childtype==type){
        logResult.push([
          logs[index].time,
          logs[index].child[i].content,
          logs[index],
        ])
     }
     }
    }
    return logResult
  }





  private getDevSensorShiduLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope !== 0) {
        if (Number(logs[index].ope.split(':')[1]) !== 0) {
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[1]),
            logs[index],
          ])
        }
      }
    }
    return logResult
  }
  private getDevSensorGzqdLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope !== 0) {
        if (Number(logs[index].ope.split(':')[2]) !== 0) {
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[2]),
            logs[index],
          ])
        }
      }
    }
    return logResult
  }

  private getDevSensorPm1LogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope !== 0) {
           
        if ((Number(logs[index].ope.split(':')[3]) !== 0)&&(logs[index].ope.split(':')[3] !='0.0')&&logs[index].ope.split(':')[3] ) {
         
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[3]),
            logs[index],
          ])
        }
      }
    }
    return logResult
  }

  private getDevSensorPm2LogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope !== 0) {
      
        
        if ((Number(logs[index].ope.split(':')[4]) !== 0)&&(logs[index].ope.split(':')[4] !='0.0')&&logs[index].ope.split(':')[4] ) {
         
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[4]),
            logs[index],
          ])
        }
      }
    }
   
    
    return logResult
    
  }

  private getDevSensorPm3LogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope !== 0) {
           
        if ((Number(logs[index].ope.split(':')[5]) !== 0)&&(logs[index].ope.split(':')[5] !='0.0')&&logs[index].ope.split(':')[5] ) {
         
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[5]),
            logs[index],
          ])
        }
      }
    }
    return logResult
  }

  private getDevSensorVOCLogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope !== 0) {
        if (Number(logs[index].ope.split(':')[6]) !== 0) {
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[6]),
            logs[index],
          ])
        }
      }
    }
    return logResult
  }

  private getDevSensorCO2LogData(
    logs: any[],
    baseVal: number,
    minTime: any,
    maxTime: any
  ) {
    let logResult: any = []
    for (let index: any = 0; index < logs.length; index++) {
      if (logs[index].ope !== 0) {
        if (Number(logs[index].ope.split(':')[7]) !== 0) {
          logResult.push([
            logs[index].time,
            Number(logs[index].ope.split(':')[7]),
            logs[index],
          ])
        }
      }
    }
    return logResult
  }

  private getPeopleData(peoples: any[]) {
    if (!peoples || !peoples.length) return []
    const lastIndex = peoples.length - 1
    if (peoples[lastIndex].people === 1) {
      peoples.push({ time: Date.now(), people: 0 })
    }
    return peoples.map((item: any) => [item.time, item.people, item])
  }
}
